export const dataUS = [
  {
    id: 1,
    category: "Goulet",
    name: "Albatros A",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 6.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, Saç kurutma makinesi. Kano, windsurf",
    photo: require("../img/boats/albatros.jpg").default,
    gallery: [
      require("../img/boats/albatros1.jpg").default,
      require("../img/boats/albatros2.jpg").default,
      require("../img/boats/albatros3.jpg").default,
      require("../img/boats/albatros4.jpg").default,
      require("../img/boats/albatros5.jpg").default,
      require("../img/boats/albatros6.jpg").default,
      require("../img/boats/albatros7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 2,
    category: "Goulet",
    name: "Alcatraz",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Buzdolabı, Fırın ve Ocak, Buz makinası, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, kano",
    photo: require("../img/boats/alcatraz.jpg").default,
    gallery: [
      require("../img/boats/alcatraz1.jpg").default,
      require("../img/boats/alcatraz2.jpg").default,
      require("../img/boats/alcatraz3.jpg").default,
      require("../img/boats/alcatraz4.jpg").default,
      require("../img/boats/alcatraz5.jpg").default,
      require("../img/boats/alcatraz6.jpg").default,
      require("../img/boats/alcatraz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 3,
    category: "Goulet",
    name: "Alessandro",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 3,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: 1,
    crew: 6,
    length: 40,
    width: 8.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinlerde, salon ve güvertede TV-Uydu ve müzik sistemi,Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Buz makinesi, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, Her kabinde minibar Jetski, Ringo, su kayağı, flyfish",
    photo: require("../img/boats/alessandro.jpg").default,
    gallery: [
      require("../img/boats/alessandro1.jpg").default,
      require("../img/boats/alessandro2.jpg").default,
      require("../img/boats/alessandro3.jpg").default,
      require("../img/boats/alessandro4.jpg").default,
      require("../img/boats/alessandro5.jpg").default,
      require("../img/boats/alessandro6.jpg").default,
      require("../img/boats/alessandro7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 4,
    category: "Goulet",
    name: "Aliko",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 27.6,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Master kabinlerde ve arka güverte de LCD TV,  Kano",
    photo: require("../img/boats/aliko.jpg").default,
    gallery: [
      require("../img/boats/aliko1.jpg").default,
      require("../img/boats/aliko2.jpg").default,
      require("../img/boats/aliko3.jpg").default,
      require("../img/boats/aliko4.jpg").default,
      require("../img/boats/aliko5.jpg").default,
      require("../img/boats/aliko6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 5,
    category: "Goulet",
    name: "Angelo II",
    harbor: "Göcek",
    capacity: 14,
    cabin: 7,
    masterCabin: 1,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD, DVD Oynatıcı, kahve makinesi, şarap soğutucu, saç kurutma makinesi, play Station 3, salonda TV, uydu müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları Su kayağı, sörf, kano",
    photo: require("../img/boats/angelotwo.jpg").default,
    gallery: [
      require("../img/boats/angelotwo1.jpg").default,
      require("../img/boats/angelotwo2.jpg").default,
      require("../img/boats/angelotwo3.jpg").default,
      require("../img/boats/angelotwo4.jpg").default,
      require("../img/boats/angelotwo5.jpg").default,
      require("../img/boats/angelotwo6.jpg").default,
      require("../img/boats/angelotwo7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 6,
    category: "Yacht",
    name: "Arif Kaptan C",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 27,
    width: 6.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, kano ücretli ,ringo ve su kayağı",
    photo: require("../img/boats/arifkaptanc.jpg").default,
    gallery: [
      require("../img/boats/arifkaptanc1.jpg").default,
      require("../img/boats/arifkaptanc2.jpg").default,
      require("../img/boats/arifkaptanc3.jpg").default,
      require("../img/boats/arifkaptanc4.jpg").default,
      require("../img/boats/arifkaptanc5.jpg").default,
      require("../img/boats/arifkaptanc6.jpg").default,
      require("../img/boats/arifkaptanc7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 7,
    category: "Goulet",
    name: "Ariva I",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 23,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: null,
    photo: require("../img/boats/arivaone.jpg").default,
    gallery: [
      require("../img/boats/arivaone1.jpg").default,
      require("../img/boats/arivaone2.jpg").default,
      require("../img/boats/arivaone3.jpg").default,
      require("../img/boats/arivaone4.jpg").default,
      require("../img/boats/arivaone5.jpg").default,
      require("../img/boats/arivaone6.jpg").default,
      require("../img/boats/arivaone7.jpg").default,
      require("../img/boats/arivaone8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 8,
    category: "Goulet",
    name: "Ariva II",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 17.5,
    width: 4.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Tüm navigasyon ekipmanı,buz yapıcı",
    photo: require("../img/boats/arivatwo.jpg").default,
    gallery: [
      require("../img/boats/arivatwo1.jpg").default,
      require("../img/boats/arivatwo2.jpg").default,
      require("../img/boats/arivatwo3.jpg").default,
      require("../img/boats/arivatwo4.jpg").default,
      require("../img/boats/arivatwo5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 9,
    category: "Goulet",
    name: "Arma",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda tv-uydu ve müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı,CD Oynatıcı, DVD Oynatıcı, kano ringo",
    photo: require("../img/boats/arma.jpg").default,
    gallery: [
      require("../img/boats/arma1.jpg").default,
      require("../img/boats/arma2.jpg").default,
      require("../img/boats/arma3.jpg").default,
      require("../img/boats/arma4.jpg").default,
      require("../img/boats/arma5.jpg").default,
      require("../img/boats/arma6.jpg").default,
      require("../img/boats/arma7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 10,
    category: "Goulet",
    name: "Aşkım Deniz",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 23,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV & DVD oynatıcı, kano",
    photo: require("../img/boats/askimdeniz.jpg").default,
    gallery: [
      require("../img/boats/askimdeniz1.jpg").default,
      require("../img/boats/askimdeniz2.jpg").default,
      require("../img/boats/askimdeniz3.jpg").default,
      require("../img/boats/askimdeniz4.jpg").default,
      require("../img/boats/askimdeniz5.jpg").default,
      require("../img/boats/askimdeniz6.jpg").default,
      require("../img/boats/askimdeniz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 11,
    category: "Goulet",
    name: "Atalante",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kahve makinesi,,Ekspresso, Salonda TV, DVD / CD oynatıcı, Müzik sistemi, Tüm kabinlerde TV, duşakabin, saç kurutma makinesi, 2 adet kano, wakeboard,, su kayağı",
    photo: require("../img/boats/atalante.jpg").default,
    gallery: [
      require("../img/boats/atalante1.jpg").default,
      require("../img/boats/atalante2.jpg").default,
      require("../img/boats/atalante3.jpg").default,
      require("../img/boats/atalante4.jpg").default,
      require("../img/boats/atalante5.jpg").default,
      require("../img/boats/atalante6.jpg").default,
      require("../img/boats/atalante7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 12,
    category: "Goulet",
    name: "Azra Can",
    harbor: "Bodrum",
    capacity: 4,
    cabin: 2,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 18.5,
    width: 5.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi,master kabinde tv, müzik sistemi,tv, kahve makinası",
    photo: require("../img/boats/azracan.jpg").default,
    gallery: [
      require("../img/boats/azracan1.jpg").default,
      require("../img/boats/azracan2.jpg").default,
      require("../img/boats/azracan3.jpg").default,
      require("../img/boats/azracan4.jpg").default,
      require("../img/boats/azracan5.jpg").default,
      require("../img/boats/azracan6.jpg").default,
      require("../img/boats/azracan7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 13,
    category: "Goulet",
    name: "Azra Deniz",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 6.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, kahve makinası, sörf, kano",
    photo: require("../img/boats/azradeniz.jpg").default,
    gallery: [
      require("../img/boats/azradeniz1.jpg").default,
      require("../img/boats/azradeniz2.jpg").default,
      require("../img/boats/azradeniz3.jpg").default,
      require("../img/boats/azradeniz4.jpg").default,
      require("../img/boats/azradeniz5.jpg").default,
      require("../img/boats/azradeniz6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 15,
    category: "Goulet",
    name: "Baba Veli 8",
    harbor: "Fethiye",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 4,
    length: 29,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda usb girişli müzik sistemi, şarap soğutucu,kahve mak. buz mak",
    photo: require("../img/boats/babavelisekiz.jpg").default,
    gallery: [
      require("../img/boats/babavelisekiz1.jpg").default,
      require("../img/boats/babavelisekiz2.jpg").default,
      require("../img/boats/babavelisekiz3.jpg").default,
      require("../img/boats/babavelisekiz4.jpg").default,
      require("../img/boats/babavelisekiz5.jpg").default,
      require("../img/boats/babavelisekiz6.jpg").default,
      require("../img/boats/babavelisekiz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 16,
    category: "Yacht",
    name: "Babosch Trawler",
    harbor: "Fethiye",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Plazma TV,müzik sistemi,Radar, GPS, Pusula, Uydu haberleşme cihazı,CD - DVD oynatıcı, Buz makinesi, Kahve makinesi, Şarap soğutucu",
    photo: require("../img/boats/babosch.jpg").default,
    gallery: [
      require("../img/boats/babosch1.jpg").default,
      require("../img/boats/babosch2.jpg").default,
      require("../img/boats/babosch3.jpg").default,
      require("../img/boats/babosch4.jpg").default,
      require("../img/boats/babosch5.jpg").default,
      require("../img/boats/babosch6.jpg").default,
      require("../img/boats/babosch7.jpg").default,
      require("../img/boats/babosch8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 17,
    category: "Goulet",
    name: "Bahriyeli A",
    harbor: "Marmaris",
    capacity: 20,
    cabin: 10,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 8,
    tripleCabin: null,
    vipCabin: null,
    crew: null,
    length: 45,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, salonda tv",
    photo: require("../img/boats/bariyelia.jpg").default,
    gallery: [
      require("../img/boats/bariyelia1.jpg").default,
      require("../img/boats/bariyelia2.jpg").default,
      require("../img/boats/bariyelia3.jpg").default,
      require("../img/boats/bariyelia4.jpg").default,
      require("../img/boats/bariyelia5.jpg").default,
      require("../img/boats/bariyelia6.jpg").default,
      require("../img/boats/bariyelia7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 18,
    category: "Goulet",
    name: "Bahriyeli C",
    harbor: "Marmaris",
    capacity: 24,
    cabin: 12,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 55,
    width: 8.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD - DVD Oynatıcı, Kahve makinesi, salonda tv uydu, kano",
    photo: require("../img/boats/bariyelic.jpg").default,
    gallery: [
      require("../img/boats/bariyelic1.jpg").default,
      require("../img/boats/bariyelic2.jpg").default,
      require("../img/boats/bariyelic3.jpg").default,
      require("../img/boats/bariyelic4.jpg").default,
      require("../img/boats/bariyelic5.jpg").default,
      require("../img/boats/bariyelic6.jpg").default,
      require("../img/boats/bariyelic7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 19,
    category: "Goulet",
    name: "Bahriyeli D",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 6,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 42,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "DVD , TV , Music Player , Wind Surf , 9.9 Hp servis botu",
    photo: require("../img/boats/bariyelid.jpg").default,
    gallery: [
      require("../img/boats/bariyelid1.jpg").default,
      require("../img/boats/bariyelid2.jpg").default,
      require("../img/boats/bariyelid3.jpg").default,
      require("../img/boats/bariyelid4.jpg").default,
      require("../img/boats/bariyelid5.jpg").default,
      require("../img/boats/bariyelid6.jpg").default,
      require("../img/boats/bariyelid7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 20,
    category: "Goulet",
    name: "Barış 3",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 4,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz yapıcı, kahve makinası, kano",
    photo: require("../img/boats/barisuc.jpg").default,
    gallery: [
      require("../img/boats/barisuc1.jpg").default,
      require("../img/boats/barisuc2.jpg").default,
      require("../img/boats/barisuc3.jpg").default,
      require("../img/boats/barisuc4.jpg").default,
      require("../img/boats/barisuc5.jpg").default,
      require("../img/boats/barisuc6.jpg").default,
      require("../img/boats/barisuc7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 21,
    category: "Goulet",
    name: "Barka",
    harbor: "Marmaris",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 22,
    width: 5.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: null,
    photo: require("../img/boats/barka.jpg").default,
    gallery: [
      require("../img/boats/barka1.jpg").default,
      require("../img/boats/barka2.jpg").default,
      require("../img/boats/barka3.jpg").default,
      require("../img/boats/barka4.jpg").default,
      require("../img/boats/barka5.jpg").default,
      require("../img/boats/barka6.jpg").default,
      require("../img/boats/barka7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 22,
    category: "Goulet",
    name: "Bedia Sultan",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: null,
    twinCabin: 3,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 7.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve kabinlerde müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Elektronik harita, Tüm seyir cihazları, Kahve makinesi, Şarap soğutucu, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, Buz makinesi, Türk karasularında internet, minibar, jakuzi, playstation 3, Su kayağı, ringo, kano, wakeskate, banana ( 3 kişilik )",
    photo: require("../img/boats/bediasultan.jpg").default,
    gallery: [
      require("../img/boats/bediasultan1.jpg").default,
      require("../img/boats/bediasultan2.jpg").default,
      require("../img/boats/bediasultan3.jpg").default,
      require("../img/boats/bediasultan4.jpg").default,
      require("../img/boats/bediasultan5.jpg").default,
      require("../img/boats/bediasultan6.jpg").default,
      require("../img/boats/bediasultan7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 23,
    category: "Goulet",
    name: "Bella Mare",
    harbor: "Göcek",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 36,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, tüm navigasyon ekipmanları,Buz makinesi, CD - DVD Oynatıcı, Kahve makinesi, Türk karasularında internet bağlantısı, Şarap soğutucu, kano,Jet ski, kano, sörf, ringo, banana, kayak.",
    photo: require("../img/boats/bellamare.jpg").default,
    gallery: [
      require("../img/boats/bellamare1.jpg").default,
      require("../img/boats/bellamare2.jpg").default,
      require("../img/boats/bellamare3.jpg").default,
      require("../img/boats/bellamare4.jpg").default,
      require("../img/boats/bellamare5.jpg").default,
      require("../img/boats/bellamare6.jpg").default,
      require("../img/boats/bellamare7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 24,
    category: "Goulet",
    name: "Berrak Su",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: 4,
    crew: 4,
    length: 32,
    width: 8.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Jakuzi ( delüks master ), Türk karasularında internet, Buz makinesi, Kahve makinesi, Şarap soğutucu, Salonda ve her kabinde CD - DVD oynatıcı, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Elektronik harita, Tüm seyir cihazları,Su kayağı, ringo, kano, sörf,, salon ve kabinlerde tv-uydu ve müzik sistemi",
    photo: require("../img/boats/berraksu.jpg").default,
    gallery: [
      require("../img/boats/berraksu1.jpg").default,
      require("../img/boats/berraksu2.jpg").default,
      require("../img/boats/berraksu3.jpg").default,
      require("../img/boats/berraksu4.jpg").default,
      require("../img/boats/berraksu5.jpg").default,
      require("../img/boats/berraksu6.jpg").default,
      require("../img/boats/berraksu7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 25,
    category: "Goulet",
    name: "Biliz",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı, Tüm kabinlerde TV & DVD oynatıcı, Tüm kabinlerde ve salonda müzik sistemi, Kano",
    photo: require("../img/boats/biliz.jpg").default,
    gallery: [
      require("../img/boats/biliz1.jpg").default,
      require("../img/boats/biliz2.jpg").default,
      require("../img/boats/biliz3.jpg").default,
      require("../img/boats/biliz4.jpg").default,
      require("../img/boats/biliz5.jpg").default,
      require("../img/boats/biliz6.jpg").default,
      require("../img/boats/biliz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 26,
    category: "Goulet",
    name: "Blue Cruise",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: 4,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7.16,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: null,
    photo: require("../img/boats/bluecruise.jpg").default,
    gallery: [
      require("../img/boats/bluecruise1.jpg").default,
      require("../img/boats/bluecruise2.jpg").default,
      require("../img/boats/bluecruise3.jpg").default,
      require("../img/boats/bluecruise4.jpg").default,
      require("../img/boats/bluecruise5.jpg").default,
      require("../img/boats/bluecruise6.jpg").default,
      require("../img/boats/bluecruise7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 27,
    category: "Goulet",
    name: "Blue Diamond",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 19,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve güvertede müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, kano",
    photo: require("../img/boats/bluediamond.jpg").default,
    gallery: [
      require("../img/boats/bluediamond1.jpg").default,
      require("../img/boats/bluediamond2.jpg").default,
      require("../img/boats/bluediamond3.jpg").default,
      require("../img/boats/bluediamond4.jpg").default,
      require("../img/boats/bluediamond5.jpg").default,
      require("../img/boats/bluediamond6.jpg").default,
      require("../img/boats/bluediamond7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 28,
    category: "Goulet",
    name: "Blue Eyes",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 32,
    width: 8.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Müzik sistemi, kabinlerde, salon ve güvertede Kabinlerde, salon ve güvertede tv uydu Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Güvertede Jakuzi, Buz makinesi, Kahve makinesi, Şarap soğutucu, Kabinlerde servis telefonu, İnternet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, 2 x 250 Hp. Jet ski, kano, su kayağı ( yakıt sarfiyatı ekstradır )",
    photo: require("../img/boats/blueeyes.jpg").default,
    gallery: [
      require("../img/boats/blueeyes1.jpg").default,
      require("../img/boats/blueeyes2.jpg").default,
      require("../img/boats/blueeyes3.jpg").default,
      require("../img/boats/blueeyes4.jpg").default,
      require("../img/boats/blueeyes5.jpg").default,
      require("../img/boats/blueeyes6.jpg").default,
      require("../img/boats/blueeyes7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 29,
    category: "Goulet",
    name: "Blue Heaven",
    harbor: "Bodrum",
    capacity: 9,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: null,
    twinCabin: 2 + 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 34,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinlerde, salon ve güvertede TV-Uydu Kabinlerde, salon ve güvertede müzik sistemi, salon ve kabinlerde tv-uydu Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Buz makinesi, Kahve makinesi, Şarap soğutucu, Kabinlerde servis telefonu, İnternet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı",
    photo: require("../img/boats/blueheaven.jpg").default,
    gallery: [
      require("../img/boats/blueheaven1.jpg").default,
      require("../img/boats/blueheaven2.jpg").default,
      require("../img/boats/blueheaven3.jpg").default,
      require("../img/boats/blueheaven4.jpg").default,
      require("../img/boats/blueheaven5.jpg").default,
      require("../img/boats/blueheaven6.jpg").default,
      require("../img/boats/blueheaven7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 30,
    category: "Goulet",
    name: "Bodrum Queen",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 27,
    width: 7.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "buz mak., filtre, türk, ve espresso kahve mak.,kano, paddle, servis botu 40 hp",
    photo: require("../img/boats/bodrumqueen.jpg").default,
    gallery: [
      require("../img/boats/bodrumqueen1.jpg").default,
      require("../img/boats/bodrumqueen2.jpg").default,
      require("../img/boats/bodrumqueen3.jpg").default,
      require("../img/boats/bodrumqueen4.jpg").default,
      require("../img/boats/bodrumqueen5.jpg").default,
      require("../img/boats/bodrumqueen6.jpg").default,
      require("../img/boats/bodrumqueen7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 31,
    category: "Goulet",
    name: "Bolero",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 16.4,
    width: 4.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: null,
    photo: require("../img/boats/bolero.jpg").default,
    gallery: [
      require("../img/boats/bolero1.jpg").default,
      require("../img/boats/bolero2.jpg").default,
      require("../img/boats/bolero3.jpg").default,
      require("../img/boats/bolero4.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 32,
    category: "Goulet",
    name: "Caferoğlu 7",
    harbor: "Marmaris",
    capacity: 22,
    cabin: 11,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 5,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 39,
    width: 9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Hifi sistem salon ve güvertede,   Salonda plazma TV,  DVD / CD oynatıcı ,  Tüm kabinlerde lcd tv ve dvd oynatıcı,, Okey Takımı ,Tavla ,Oyun Kağıdı Kano ,Snorkel, Maske, Palet,4,20 mt joker bot, su kayağı, ringo,2 kano",
    photo: require("../img/boats/caferogluyedi.jpg").default,
    gallery: [
      require("../img/boats/caferogluyedi1.jpg").default,
      require("../img/boats/caferogluyedi2.jpg").default,
      require("../img/boats/caferogluyedi3.jpg").default,
      require("../img/boats/caferogluyedi4.jpg").default,
      require("../img/boats/caferogluyedi5.jpg").default,
      require("../img/boats/caferogluyedi6.jpg").default,
      require("../img/boats/caferogluyedi7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 33,
    category: "Goulet",
    name: "Caferoğlu 8",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 34,
    width: 7.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Hifi sistem salon ve güvertede,   Salonda plazma TV,  DVD / CD oynatıcı ,  Tüm kabinlerde lcd tv ve dvd oynatıcı,, Okey Takımı ,Tavla ,Oyun Kağıdı Kano ,Snorkel, Maske, Palet,4,20 mt 40hp joker bot, su kayağı, ringo,kano",
    photo: require("../img/boats/caferoglusekiz.jpg").default,
    gallery: [
      require("../img/boats/caferoglusekiz1.jpg").default,
      require("../img/boats/caferoglusekiz2.jpg").default,
      require("../img/boats/caferoglusekiz3.jpg").default,
      require("../img/boats/caferoglusekiz4.jpg").default,
      require("../img/boats/caferoglusekiz5.jpg").default,
      require("../img/boats/caferoglusekiz6.jpg").default,
      require("../img/boats/caferoglusekiz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 34,
    category: "Goulet",
    name: "Caner IV",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 36,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve kabinlerde TV-Uydu ve müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Gece Klima Kullanımı, CD Oynatıcı, DVD Oynatıcı, Türk karasularında internet bağlantısı, Saç kurutma makinesi Su Oyuncakları Jet ski (opsiyonal), su kayağı, ringo",
    photo: require("../img/boats/canerdort.jpg").default,
    gallery: [
      require("../img/boats/canerdort1.jpg").default,
      require("../img/boats/canerdort2.jpg").default,
      require("../img/boats/canerdort3.jpg").default,
      require("../img/boats/canerdort4.jpg").default,
      require("../img/boats/canerdort5.jpg").default,
      require("../img/boats/canerdort6.jpg").default,
      require("../img/boats/canerdort7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 35,
    category: "Goulet",
    name: "Carpediem V",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 42,
    width: null,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, salon ve güvertede müzik sistemi,, TV-Uydu, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları,Gece Klima Kullanımı, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, 115 Hp.motor bot Su Oyuncakları, Jet ski ( fiyata dahil değildir ), su kayağı, kano, ringo, banana, wakeboard",
    photo: require("../img/boats/carpediembes.jpg").default,
    gallery: [
      require("../img/boats/carpediembes1.jpg").default,
      require("../img/boats/carpediembes2.jpg").default,
      require("../img/boats/carpediembes3.jpg").default,
      require("../img/boats/carpediembes4.jpg").default,
      require("../img/boats/carpediembes5.jpg").default,
      require("../img/boats/carpediembes6.jpg").default,
      require("../img/boats/carpediembes7.jpg").default,
      require("../img/boats/carpediembes8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 36,
    category: "Goulet",
    name: "Casa Del Arte II",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 3,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 35,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda VCD & DVD Player Tüm kabinlerde VHF Radio DVD Player Full Navigation Ekipmanları Internet, Salonda TV & DVD & Müzik Sistemi, Tüm kabinlerde müzik sistemi,dvd oynatıcı, led aydınlatma, duşakabin, saç kurutma makinesi Knee Board , Wake Board, Ringo, Jet ski, Su Kayağı, Kano 2 Adet",
    photo: require("../img/boats/casadelarte.jpg").default,
    gallery: [
      require("../img/boats/casadelarte1.jpg").default,
      require("../img/boats/casadelarte2.jpg").default,
      require("../img/boats/casadelarte3.jpg").default,
      require("../img/boats/casadelarte4.jpg").default,
      require("../img/boats/casadelarte5.jpg").default,
      require("../img/boats/casadelarte6.jpg").default,
      require("../img/boats/casadelarte7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 37,
    category: "Goulet",
    name: "Çelik Es D",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, her kabinde, duşakabin, su kayağı, ringo, wake board, windsurf, kano",
    photo: require("../img/boats/celikes.jpg").default,
    gallery: [
      require("../img/boats/celikes1.jpg").default,
      require("../img/boats/celikes2.jpg").default,
      require("../img/boats/celikes3.jpg").default,
      require("../img/boats/celikes4.jpg").default,
      require("../img/boats/celikes5.jpg").default,
      require("../img/boats/celikes6.jpg").default,
      require("../img/boats/celikes7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 38,
    category: "Goulet",
    name: "Cemre IV",
    harbor: "Bodrum",
    capacity: 18,
    cabin: 9,
    masterCabin: 1,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 5,
    length: 31,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Yelken Donanımı, İpad bağlantısı , Mikrodalga fırın , Tost Makinesi , Bulaşık makinesi, Kahve makinesi , Salonda TV, Salonda DVD / CD oynatıcı , Salonda Müzik sistemi ,Salonda Klima ,Tüm kabinlerde klima tüm kabinlerde duşakabin ,Tüm kabinlerde ev tipi WC , Okey Takımı ,Tavla ,Oyun Kağıdı Kano ,Snorkel, Maske, Palet, Windsurf, Banana, Ringo",
    photo: require("../img/boats/cemredort.jpg").default,
    gallery: [
      require("../img/boats/cemredort1.jpg").default,
      require("../img/boats/cemredort2.jpg").default,
      require("../img/boats/cemredort3.jpg").default,
      require("../img/boats/cemredort4.jpg").default,
      require("../img/boats/cemredort5.jpg").default,
      require("../img/boats/cemredort6.jpg").default,
      require("../img/boats/cemredort7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 39,
    category: "Goulet",
    name: "Cemre Junior",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "İnternet , Her kabinde Duşakabin minderleri Güvertede Mini Bar Mikrodalga fırın Tost Makinesi Bulaşık makinesi Kahve makinesi Ekspresso Filtre kahve makinesi Salonda TV DVD / CD oynatıcı Salonda Müzik sistemi , Kllima , Wake Board Windsurf, Ringo,Su Kayağı,Kano 2 Adet",
    photo: require("../img/boats/cemrejr.jpg").default,
    gallery: [
      require("../img/boats/cemrejr1.jpg").default,
      require("../img/boats/cemrejr2.jpg").default,
      require("../img/boats/cemrejr3.jpg").default,
      require("../img/boats/cemrejr4.jpg").default,
      require("../img/boats/cemrejr5.jpg").default,
      require("../img/boats/cemrejr6.jpg").default,
      require("../img/boats/cemrejr7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 40,
    category: "Goulet",
    name: "Cevri Hasan IV",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda DVD , TV ve müzik sistemi Kano",
    photo: require("../img/boats/cevrihasandort.jpg").default,
    gallery: [
      require("../img/boats/cevrihasandort1.jpg").default,
      require("../img/boats/cevrihasandort2.jpg").default,
      require("../img/boats/cevrihasandort3.jpg").default,
      require("../img/boats/cevrihasandort4.jpg").default,
      require("../img/boats/cevrihasandort5.jpg").default,
      require("../img/boats/cevrihasandort6.jpg").default,
      require("../img/boats/cevrihasandort7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 41,
    category: "Goulet",
    name: "Cevri Hasan V",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda DVD , TV ve ,müzik sistemi, Kano ve rüzgar sörfü",
    photo: require("../img/boats/cevrihasanbes.jpg").default,
    gallery: [
      require("../img/boats/cevrihasanbes1.jpg").default,
      require("../img/boats/cevrihasanbes2.jpg").default,
      require("../img/boats/cevrihasanbes3.jpg").default,
      require("../img/boats/cevrihasanbes4.jpg").default,
      require("../img/boats/cevrihasanbes5.jpg").default,
      require("../img/boats/cevrihasanbes6.jpg").default,
      require("../img/boats/cevrihasanbes7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 42,
    category: "Goulet",
    name: "Ceyda II",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 22,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula,",
    photo: require("../img/boats/ceydaki.jpg").default,
    gallery: [
      require("../img/boats/ceydaki1.jpg").default,
      require("../img/boats/ceydaki2.jpg").default,
      require("../img/boats/ceydaki3.jpg").default,
      require("../img/boats/ceydaki4.jpg").default,
      require("../img/boats/ceydaki5.jpg").default,
      require("../img/boats/ceydaki6.jpg").default,
      require("../img/boats/ceydaki7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 43,
    category: "Goulet",
    name: "Cobra III",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 27,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda ve güvertede müzik sistemi, salon ve kabinlerde TV-uydu, Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi",
    photo: require("../img/boats/cobrauc.jpg").default,
    gallery: [
      require("../img/boats/cobrauc1.jpg").default,
      require("../img/boats/cobrauc2.jpg").default,
      require("../img/boats/cobrauc3.jpg").default,
      require("../img/boats/cobrauc4.jpg").default,
      require("../img/boats/cobrauc5.jpg").default,
      require("../img/boats/cobrauc6.jpg").default,
      require("../img/boats/cobrauc7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 44,
    category: "Goulet",
    name: "Cobra King",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 34,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabin, salon ve güvertede müzik sistemi, salon ve kabinlerde tv-uydu,Su kayağı, ringo, kano, wakeskate, banana ( 3 kişilik ), CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Su kayağı yetişkinler ve çocuklar için, kneeboard, wakeboard, paddle board, water sofa, ringo ve kano",
    photo: require("../img/boats/cobraking.jpg").default,
    gallery: [
      require("../img/boats/cobraking1.jpg").default,
      require("../img/boats/cobraking2.jpg").default,
      require("../img/boats/cobraking3.jpg").default,
      require("../img/boats/cobraking4.jpg").default,
      require("../img/boats/cobraking5.jpg").default,
      require("../img/boats/cobraking6.jpg").default,
      require("../img/boats/cobraking7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 45,
    category: "Goulet",
    name: "Cosh",
    harbor: "Bodrum",
    capacity: 4,
    cabin: 2,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 16,
    width: 4.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, kahve makinası",
    photo: require("../img/boats/cosh.jpg").default,
    gallery: [
      require("../img/boats/cosh1.jpg").default,
      require("../img/boats/cosh2.jpg").default,
      require("../img/boats/cosh3.jpg").default,
      require("../img/boats/cosh4.jpg").default,
      require("../img/boats/cosh5.jpg").default,
      require("../img/boats/cosh6.jpg").default,
      require("../img/boats/cosh7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 46,
    category: "Goulet",
    name: "Daima",
    harbor: "Antalya",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: null,
    length: 43,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, Salon ve Güvertede TV-Uydu ve müzik sistemi Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Buz makinesi, , Kahve makinesi, Şarap soğutucu, Kabinlerde servis telefonu, İnternet bağlantısı, Saç kurutma makinesi, Her kabinde kilitli kasa, Salonda ve her kabinde CD - DVD oynatıcı 160 Hp. Waterjet, Jet ski, su kayağı, wakeboard, Kneeboard, Rüzgar sörfü",
    photo: require("../img/boats/daima.jpg").default,
    gallery: [
      require("../img/boats/daima1.jpg").default,
      require("../img/boats/daima2.jpg").default,
      require("../img/boats/daima3.jpg").default,
      require("../img/boats/daima4.jpg").default,
      require("../img/boats/daima5.jpg").default,
      require("../img/boats/daima6.jpg").default,
      require("../img/boats/daima7.jpg").default,
      require("../img/boats/daima8.jpg").default,
      require("../img/boats/daima9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 47,
    category: "Goulet",
    name: "Dae Del Mare",
    harbor: "Marmaris",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: 1,
    crew: 4,
    length: 28,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, Salon ve Güvertede TV-Uydu ve müzik sistemi Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Buz makinesi, , Kahve makinesi, Şarap soğutucu, , İnternet bağlantısı, Saç kurutma makinesi,  Salonda ve her kabinde CD - DVD oynatıcı ",
    photo: require("../img/boats/daedelmare.jpg").default,
    gallery: [
      require("../img/boats/daedelmare1.jpg").default,
      require("../img/boats/daedelmare2.jpg").default,
      require("../img/boats/daedelmare3.jpg").default,
      require("../img/boats/daedelmare4.jpg").default,
      require("../img/boats/daedelmare5.jpg").default,
      require("../img/boats/daedelmare6.jpg").default,
      require("../img/boats/daedelmare7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 48,
    category: "Goulet",
    name: "Dear Lila",
    harbor: "Göcek",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda led TV, DVD ve müzik sistemi, internet, i pod girişi, wifi oyunları, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, kano, rüzgar sörfü",
    photo: require("../img/boats/dearlila.jpg").default,
    gallery: [
      require("../img/boats/dearlila1.jpg").default,
      require("../img/boats/dearlila2.jpg").default,
      require("../img/boats/dearlila3.jpg").default,
      require("../img/boats/dearlila4.jpg").default,
      require("../img/boats/dearlila5.jpg").default,
      require("../img/boats/dearlila6.jpg").default,
      require("../img/boats/dearlila7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 49,
    category: "Goulet",
    name: "Deniz 61",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24.5,
    width: 7.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Dvd,oynatıcı uydu, müzik sistemi, kano",
    photo: require("../img/boats/denizaltmisbir.jpg").default,
    gallery: [
      require("../img/boats/denizaltmisbir1.jpg").default,
      require("../img/boats/denizaltmisbir2.jpg").default,
      require("../img/boats/denizaltmisbir3.jpg").default,
      require("../img/boats/denizaltmisbir4.jpg").default,
      require("../img/boats/denizaltmisbir5.jpg").default,
      require("../img/boats/denizaltmisbir6.jpg").default,
      require("../img/boats/denizaltmisbir7.jpg").default,
      require("../img/boats/denizaltmisbir8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 50,
    category: "Goulet",
    name: "Deniz C",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 5.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    photo: require("../img/boats/denizc.jpg").default,
    gallery: [
      require("../img/boats/denizc1.jpg").default,
      require("../img/boats/denizc2.jpg").default,
      require("../img/boats/denizc3.jpg").default,
      require("../img/boats/denizc4.jpg").default,
      require("../img/boats/denizc5.jpg").default,
      require("../img/boats/denizc6.jpg").default,
      require("../img/boats/denizc7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 51,
    category: "Goulet",
    name: "Derin Deniz",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 27,
    width: 6.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Internet ,salonda DVD , TV ve müzik sistemi, kano, 80 hp motor bot",
    photo: require("../img/boats/derindeniz.jpg").default,
    gallery: [
      require("../img/boats/derindeniz1.jpg").default,
      require("../img/boats/derindeniz2.jpg").default,
      require("../img/boats/derindeniz3.jpg").default,
      require("../img/boats/derindeniz4.jpg").default,
      require("../img/boats/derindeniz5.jpg").default,
      require("../img/boats/derindeniz6.jpg").default,
      require("../img/boats/derindeniz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 52,
    category: "Goulet",
    name: "Derya Deniz",
    harbor: "Marmaris",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "TV-Uydu ve müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, , Kahve makinesi, Şarap soğutucu,, Saç kurutma makinesi, Salonda ve kabinlerde TV, CD - DVD oynatıcı,  kano, Ringo, su kayağı,",
    photo: require("../img/boats/deryadeniz.jpg").default,
    gallery: [
      require("../img/boats/deryadeniz1.jpg").default,
      require("../img/boats/deryadeniz2.jpg").default,
      require("../img/boats/deryadeniz3.jpg").default,
      require("../img/boats/deryadeniz4.jpg").default,
      require("../img/boats/deryadeniz5.jpg").default,
      require("../img/boats/deryadeniz6.jpg").default,
      require("../img/boats/deryadeniz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 53,
    category: "Goulet",
    name: "Didi",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, Kahve makinesi, İnternet bağlantısı, Saç kurutma makinesi.,Kano, Jet ski (OPSİYONEL)Haberleşme cihazı, Derinlik ölçer, Radar",
    photo: require("../img/boats/didi.jpg").default,
    gallery: [
      require("../img/boats/didi1.jpg").default,
      require("../img/boats/didi2.jpg").default,
      require("../img/boats/didi3.jpg").default,
      require("../img/boats/didi4.jpg").default,
      require("../img/boats/didi5.jpg").default,
      require("../img/boats/didi6.jpg").default,
      require("../img/boats/didi7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 54,
    category: "Goulet",
    name: "Diva Deniz",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 29,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV, DVD / CD oynatıcı ve müzik sistemi, Tüm kabinlerde klima ve TV DVD ve duşakabin Kano, Ringo (opsiyonel), rüzgar sörfü",
    photo: require("../img/boats/divadeniz.jpg").default,
    gallery: [
      require("../img/boats/divadeniz1.jpg").default,
      require("../img/boats/divadeniz2.jpg").default,
      require("../img/boats/divadeniz3.jpg").default,
      require("../img/boats/divadeniz4.jpg").default,
      require("../img/boats/divadeniz5.jpg").default,
      require("../img/boats/divadeniz6.jpg").default,
      require("../img/boats/divadeniz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 55,
    category: "Goulet",
    name: "Dolca Mare",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 36,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, tüm kabinlerde TV, DVD, Müzik sistemi, uydu, internet, Güvertede Jakuzi, Buz makinesi, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, 90 hp motor bot Jet Ski, Kano, Rüzgar Sörfü, Su Kayağı, Wake Board, Ringo, Sea Scooter",
    photo: require("../img/boats/dolcemare.jpg").default,
    gallery: [
      require("../img/boats/dolcemare1.jpg").default,
      require("../img/boats/dolcemare2.jpg").default,
      require("../img/boats/dolcemare3.jpg").default,
      require("../img/boats/dolcemare4.jpg").default,
      require("../img/boats/dolcemare5.jpg").default,
      require("../img/boats/dolcemare6.jpg").default,
      require("../img/boats/dolcemare7.jpg").default,
      require("../img/boats/dolcemare8.jpg").default,
      require("../img/boats/dolcemare9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 56,
    category: "Goulet",
    name: "Dolce Vita",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: 1,
    vipCabin: null,
    crew: 5,
    length: 34,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Her kabinde duşakabin, saç kurutma makinası, salon ve kabinlerde müzik sistemi, salonda dvd oynatıcı , TV, Internet , güvertede jakuzi, Su Sporları: Wsu kayağı, kano, rüzgar sörfü, jetski ( opsiyonel)",
    photo: require("../img/boats/dolcevita.jpg").default,
    gallery: [
      require("../img/boats/dolcevita1.jpg").default,
      require("../img/boats/dolcevita2.jpg").default,
      require("../img/boats/dolcevita3.jpg").default,
      require("../img/boats/dolcevita4.jpg").default,
      require("../img/boats/dolcevita5.jpg").default,
      require("../img/boats/dolcevita6.jpg").default,
      require("../img/boats/dolcevita7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 57,
    category: "Goulet",
    name: "Dora Deniz",
    harbor: "Marmaris",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 18.5,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV Salonda DVD / CD oynatıcı, Müzik sistemi,Tüm kabinlerde duşakabin",
    photo: require("../img/boats/doradeniz.jpg").default,
    gallery: [
      require("../img/boats/doradeniz1.jpg").default,
      require("../img/boats/doradeniz2.jpg").default,
      require("../img/boats/doradeniz3.jpg").default,
      require("../img/boats/doradeniz4.jpg").default,
      require("../img/boats/doradeniz5.jpg").default,
      require("../img/boats/doradeniz6.jpg").default,
      require("../img/boats/doradeniz7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 58,
    category: "Goulet",
    name: "Double Eagle",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 38,
    width: 7.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kano, su kayağı, knee board, wake board, aqua lunch, jet ski, banana, ringo, 115 hp joker boat",
    photo: require("../img/boats/doubleeagle.jpg").default,
    gallery: [
      require("../img/boats/doubleeagle1.jpg").default,
      require("../img/boats/doubleeagle2.jpg").default,
      require("../img/boats/doubleeagle3.jpg").default,
      require("../img/boats/doubleeagle4.jpg").default,
      require("../img/boats/doubleeagle5.jpg").default,
      require("../img/boats/doubleeagle6.jpg").default,
      require("../img/boats/doubleeagle7.jpg").default,
      require("../img/boats/doubleeagle8.jpg").default,
      require("../img/boats/doubleeagle9.jpg").default,
      require("../img/boats/doubleeagle10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 59,
    category: "Goulet",
    name: "Dragon Fly",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: 2,
    crew: 5,
    length: 41,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, salon ve güvertede müzik sistemi, kabin ve salonda tv-uydu, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları Gece Klima Kullanımı, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, kabinlerde kasa,",
    photo: require("../img/boats/dragonfly.jpg").default,
    gallery: [
      require("../img/boats/dragonfly1.jpg").default,
      require("../img/boats/dragonfly2.jpg").default,
      require("../img/boats/dragonfly3.jpg").default,
      require("../img/boats/dragonfly4.jpg").default,
      require("../img/boats/dragonfly5.jpg").default,
      require("../img/boats/dragonfly6.jpg").default,
      require("../img/boats/dragonfly7.jpg").default,
      require("../img/boats/dragonfly8.jpg").default,
      require("../img/boats/dragonfly9.jpg").default,
      require("../img/boats/dragonfly10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 60,
    category: "Goulet",
    name: "Dreamland",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: null,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "	Salonda TV & DVD & Müzik Sistemi ,Her kabinde WC + Duşakabin Kano ve rüzgar sörfü",
    photo: require("../img/boats/dreamland.jpg").default,
    gallery: [
      require("../img/boats/dreamland1.jpg").default,
      require("../img/boats/dreamland2.jpg").default,
      require("../img/boats/dreamland3.jpg").default,
      require("../img/boats/dreamland4.jpg").default,
      require("../img/boats/dreamland5.jpg").default,
      require("../img/boats/dreamland6.jpg").default,
      require("../img/boats/dreamland7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 61,
    category: "Goulet",
    name: "Ecce Naviga",
    harbor: "Marmaris",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 7.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları,CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Master kabinde CD - DVD oynatıcı",
    photo: require("../img/boats/eccenaviga.jpg").default,
    gallery: [
      require("../img/boats/eccenaviga1.jpg").default,
      require("../img/boats/eccenaviga2.jpg").default,
      require("../img/boats/eccenaviga3.jpg").default,
      require("../img/boats/eccenaviga4.jpg").default,
      require("../img/boats/eccenaviga5.jpg").default,
      require("../img/boats/eccenaviga6.jpg").default,
      require("../img/boats/eccenaviga7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 62,
    category: "Goulet",
    name: "Ece Arina",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 1,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda, kabinlerde ve güvertede TV-Uydu, TV ve internet kabinlerde, salonda, kıç üstünde. , Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Elektronik harita, Tüm seyir cihazları, Oto pilot., Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, Her kabinde USP bağlantılı TV. su kayağı wakeboard, sörf",
    photo: require("../img/boats/ecearina.jpg").default,
    gallery: [
      require("../img/boats/ecearina1.jpg").default,
      require("../img/boats/ecearina2.jpg").default,
      require("../img/boats/ecearina3.jpg").default,
      require("../img/boats/ecearina4.jpg").default,
      require("../img/boats/ecearina5.jpg").default,
      require("../img/boats/ecearina6.jpg").default,
      require("../img/boats/ecearina7.jpg").default,
      require("../img/boats/ecearina8.jpg").default,
      require("../img/boats/ecearina9.jpg").default,
      require("../img/boats/ecearina10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 63,
    category: "Goulet",
    name: "Ece Sultan",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Müzik Sistemi, VHF Radio DVD Player, salonda TV & DVD & müzik Sistemi, her Cabinde WC + DuşaCabin",
    photo: require("../img/boats/ecesultan.jpg").default,
    gallery: [
      require("../img/boats/ecesultan1.jpg").default,
      require("../img/boats/ecesultan2.jpg").default,
      require("../img/boats/ecesultan3.jpg").default,
      require("../img/boats/ecesultan4.jpg").default,
      require("../img/boats/ecesultan5.jpg").default,
      require("../img/boats/ecesultan6.jpg").default,
      require("../img/boats/ecesultan7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 64,
    category: "Goulet",
    name: "Elifim XI",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 22,
    width: 5.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve güvertede müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, kano",
    photo: require("../img/boats/elifim.jpg").default,
    gallery: [
      require("../img/boats/elifim1.jpg").default,
      require("../img/boats/elifim2.jpg").default,
      require("../img/boats/elifim3.jpg").default,
      require("../img/boats/elifim4.jpg").default,
      require("../img/boats/elifim5.jpg").default,
      require("../img/boats/elifim6.jpg").default,
      require("../img/boats/elifim7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 65,
    category: "Goulet",
    name: "Enderim A",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 29,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Buz makinesi, salonda CD, DVD Oynatıcı ve müzik sistemi Kahve makinesi, Türk karasularında internet bağlantısı, tüm kabinlerde duşakabin Kano, wind surf, ringo",
    photo: require("../img/boats/enderima.jpg").default,
    gallery: [
      require("../img/boats/enderima1.jpg").default,
      require("../img/boats/enderima2.jpg").default,
      require("../img/boats/enderima3.jpg").default,
      require("../img/boats/enderima4.jpg").default,
      require("../img/boats/enderima5.jpg").default,
      require("../img/boats/enderima6.jpg").default,
      require("../img/boats/enderima7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },

  {
    id: 66,
    category: "Goulet",
    name: "Esma Sultan",
    harbor: "Göcek",
    capacity: 7,
    cabin: 1,
    masterCabin: 4,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 38,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD oynatıcı, kahve makinesi, şarap soğutucu, şaç kurutma makinesi, her kabinde CD DVD oynatıcı, masajlı duş unitesi, müzik sistemi., Türk karasularında internet bağlantısı. Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı,  Elektronik harita, Tüm seyir cihazları, Su kayağı, ringo, kano, sörf, 75 hp servis botu",
    photo: require("../img/boats/esmasultan.jpg").default,
    gallery: [
      require("../img/boats/esmasultan1.jpg").default,
      require("../img/boats/esmasultan2.jpg").default,
      require("../img/boats/esmasultan3.jpg").default,
      require("../img/boats/esmasultan4.jpg").default,
      require("../img/boats/esmasultan5.jpg").default,
      require("../img/boats/esmasultan6.jpg").default,
      require("../img/boats/esmasultan7.jpg").default,
      require("../img/boats/esmasultan8.jpg").default,
      require("../img/boats/esmasultan9.jpg").default,
      require("../img/boats/esmasultan10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 67,
    category: "Goulet",
    name: "Esma Sultan II",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda ve kabinlerde müzik sistemi ve TV-uydu,, kano, su kayağı, ringo",
    photo: require("../img/boats/esmasultaniki.jpg").default,
    gallery: [
      require("../img/boats/esmasultaniki1.jpg").default,
      require("../img/boats/esmasultaniki2.jpg").default,
      require("../img/boats/esmasultaniki3.jpg").default,
      require("../img/boats/esmasultaniki4.jpg").default,
      require("../img/boats/esmasultaniki5.jpg").default,
      require("../img/boats/esmasultaniki6.jpg").default,
      require("../img/boats/esmasultaniki7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },

  {
    id: 68,
    category: "Goulet",
    name: "Esperenza ",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 25,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV, DVD oynatıcı ve müzik sistemi",
    photo: require("../img/boats/esperenza.jpg").default,
    gallery: [
      require("../img/boats/esperenza1.jpg").default,
      require("../img/boats/esperenza2.jpg").default,
      require("../img/boats/esperenza3.jpg").default,
      require("../img/boats/esperenza4.jpg").default,
      require("../img/boats/esperenza5.jpg").default,
      require("../img/boats/esperenza6.jpg").default,
      require("../img/boats/esperenza7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 69,
    category: "Goulet",
    name: "Esterella Del Mar",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 7.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları,Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, Kano, su kayağı, rüzgar sörfü",
    photo: require("../img/boats/esterella.jpg").default,
    gallery: [
      require("../img/boats/esterella1.jpg").default,
      require("../img/boats/esterella2.jpg").default,
      require("../img/boats/esterella3.jpg").default,
      require("../img/boats/esterella4.jpg").default,
      require("../img/boats/esterella5.jpg").default,
      require("../img/boats/esterella6.jpg").default,
      require("../img/boats/esterella7.jpg").default,
      require("../img/boats/esterella8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },

  {
    id: 70,
    category: "Yacht",
    name: "Faralya",
    harbor: "Fethiye",
    capacity: 8,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 5.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano, servis botu",
    photo: require("../img/boats/faralya.jpg").default,
    gallery: [
      require("../img/boats/faralya1.jpg").default,
      require("../img/boats/faralya2.jpg").default,
      require("../img/boats/faralya3.jpg").default,
      require("../img/boats/faralya4.jpg").default,
      require("../img/boats/faralya5.jpg").default,
      require("../img/boats/faralya6.jpg").default,
      require("../img/boats/faralya7.jpg").default,
      require("../img/boats/faralya8.jpg").default,
      require("../img/boats/faralya9.jpg").default,
      require("../img/boats/faralya10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 71,
    category: "Goulet",
    name: "Fatoş",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 8,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV & DVD & Müzik Sistemi, Kano",
    photo: require("../img/boats/fatos.jpg").default,
    gallery: [
      require("../img/boats/fatos1.jpg").default,
      require("../img/boats/fatos2.jpg").default,
      require("../img/boats/fatos3.jpg").default,
      require("../img/boats/fatos4.jpg").default,
      require("../img/boats/fatos5.jpg").default,
      require("../img/boats/fatos6.jpg").default,
      require("../img/boats/fatos7.jpg").default,
      require("../img/boats/fatos8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },

  {
    id: 72,
    category: "Goulet",
    name: "Felix Balina",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 33,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV, DVD / CD oynatıcı, Müzik sistemi ve Minibar 50 hp motor bot, kano, su kayağı, wakeboard, ringo, monu ski.",
    photo: require("../img/boats/felixbalina.jpg").default,
    gallery: [
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
      require("../img/boats/felixbalina.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 73,
    category: "Goulet",
    name: "Feraye",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 4,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano, wind surf",
    photo: require("../img/boats/feraye.jpg").default,
    gallery: [
      require("../img/boats/feraye1.jpg").default,
      require("../img/boats/feraye2.jpg").default,
      require("../img/boats/feraye3.jpg").default,
      require("../img/boats/feraye4.jpg").default,
      require("../img/boats/feraye5.jpg").default,
      require("../img/boats/feraye6.jpg").default,
      require("../img/boats/feraye7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 74,
    category: "Yacht",
    name: "Flamingo",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 24,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Su yapıcı,filtre kahve makinası, müzik sistemi, master kabin ve salonda TV, duşa kabin, saç kurutma makinası,Mikrodalga fırın, Tost Makinesi,Bulaşık makinesi,Kahve makinesi,Filtre kahve makinesi,Şarap soğutucu, Salonda Sinema sistemi Master kabinde sinema sistemi",
    photo: require("../img/boats/flamingo.jpg").default,
    gallery: [
      require("../img/boats/flamingo1.jpg").default,
      require("../img/boats/flamingo2.jpg").default,
      require("../img/boats/flamingo3.jpg").default,
      require("../img/boats/flamingo4.jpg").default,
      require("../img/boats/flamingo5.jpg").default,
      require("../img/boats/flamingo6.jpg").default,
      require("../img/boats/flamingo7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 75,
    category: "Goulet",
    name: "Flash VII",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: 4,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: 1,
    vipCabin: null,
    crew: 4,
    length: 33.5,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "DVD , TV müzik sistemi salonda  ,60 Hp dinghy",
    photo: require("../img/boats/flash.jpg").default,
    gallery: [
      require("../img/boats/flash1.jpg").default,
      require("../img/boats/flash2.jpg").default,
      require("../img/boats/flash3.jpg").default,
      require("../img/boats/flash4.jpg").default,
      require("../img/boats/flash5.jpg").default,
      require("../img/boats/flash6.jpg").default,
      require("../img/boats/flash7.jpg").default,
      require("../img/boats/flash8.jpg").default,
      require("../img/boats/flash9.jpg").default,
      require("../img/boats/flash10.jpg").default,
      require("../img/boats/flash11.jpg").default,
      require("../img/boats/flash12.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 76,
    category: "Yacht",
    name: "Fortuna II",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: 2,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 40,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "salonda müzik sistemi, dvd, tv, jetski, ringo, windsurf, wakeboard, banana, su kayağı, kano",
    photo: require("../img/boats/fortuna.jpg").default,
    gallery: [
      require("../img/boats/fortuna1.jpg").default,
      require("../img/boats/fortuna2.jpg").default,
      require("../img/boats/fortuna3.jpg").default,
      require("../img/boats/fortuna4.jpg").default,
      require("../img/boats/fortuna5.jpg").default,
      require("../img/boats/fortuna6.jpg").default,
      require("../img/boats/fortuna7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 77,
    category: "Goulet",
    name: "Freya",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 23,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, salonda ve güvertede müzik sistemi ve tv - uydu, Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, İnternet bağlantısı, 2 adet Kano, sörf, çocuk su kayağı, yetişkin su kayağı, wakeboard, kneeboard, ringo",
    photo: require("../img/boats/freya.jpg").default,
    gallery: [
      require("../img/boats/freya1.jpg").default,
      require("../img/boats/freya2.jpg").default,
      require("../img/boats/freya3.jpg").default,
      require("../img/boats/freya4.jpg").default,
      require("../img/boats/freya5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 78,
    category: "Goulet",
    name: "Furkan III",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: null,
    length: 24,
    width: 6.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "	Güvertede TV, Uydu Anten, İpad bağlantısı, Mikrodalga fırın, Kahve makinesi, Ekspresso ,Salonda TV- DVD / CD oynatıcı Müzik sistemi, Tüm kabinlerde TV ve hidro masajlı duş, kano, su kayağı, 60 hp motor bot",
    photo: require("../img/boats/furkanuc.jpg").default,
    gallery: [
      require("../img/boats/furkanuc1.jpg").default,
      require("../img/boats/furkanuc2.jpg").default,
      require("../img/boats/furkanuc3.jpg").default,
      require("../img/boats/furkanuc4.jpg").default,
      require("../img/boats/furkanuc5.jpg").default,
      require("../img/boats/furkanuc6.jpg").default,
      require("../img/boats/furkanuc7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 79,
    category: "Goulet",
    name: "Gemibaşı",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 23,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda DVD , TV ,müzik sistemi, kano, rüzgar sörfü, motor bot 60 hp",
    photo: require("../img/boats/gemibasi.jpg").default,
    gallery: [
      require("../img/boats/gemibasi1.jpg").default,
      require("../img/boats/gemibasi2.jpg").default,
      require("../img/boats/gemibasi3.jpg").default,
      require("../img/boats/gemibasi4.jpg").default,
      require("../img/boats/gemibasi5.jpg").default,
      require("../img/boats/gemibasi6.jpg").default,
      require("../img/boats/gemibasi7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 80,
    category: "Goulet",
    name: "Get A Way",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 31.6,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, Salon ve Güvertede müzik sistemi,TV-Uydu, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Gece Klima Kullanımı, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, Playstation 3 & Oyun, Ipod bağlantısı, 100 adet film ve albüm arşivi,75 Hp.motor bot, 2 adet tekli kano, 2 adet ringo, su kayağı, tekli kayak, wakeboard, kneeboard",
    photo: require("../img/boats/getaway.jpg").default,
    gallery: [
      require("../img/boats/getaway1.jpg").default,
      require("../img/boats/getaway2.jpg").default,
      require("../img/boats/getaway3.jpg").default,
      require("../img/boats/getaway4.jpg").default,
      require("../img/boats/getaway5.jpg").default,
      require("../img/boats/getaway6.jpg").default,
      require("../img/boats/getaway7.jpg").default,
      require("../img/boats/getaway8.jpg").default,
      require("../img/boats/getaway9.jpg").default,
      require("../img/boats/getaway10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 81,
    category: "Goulet",
    name: "Gökçe",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 25,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano, salonda TV",
    photo: require("../img/boats/gokce.jpg").default,
    gallery: [
      require("../img/boats/gokce1.jpg").default,
      require("../img/boats/gokce2.jpg").default,
      require("../img/boats/gokce3.jpg").default,
      require("../img/boats/gokce4.jpg").default,
      require("../img/boats/gokce5.jpg").default,
      require("../img/boats/gokce6.jpg").default,
      require("../img/boats/gokce7.jpg").default,
      require("../img/boats/gokce8.jpg").default,
      require("../img/boats/gokce9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 82,
    category: "Goulet",
    name: "Golden Glory",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV  ve müzik sistemi, kano",
    photo: require("../img/boats/goldenglory.jpg").default,
    gallery: [
      require("../img/boats/goldenglory1.jpg").default,
      require("../img/boats/goldenglory2.jpg").default,
      require("../img/boats/goldenglory3.jpg").default,
      require("../img/boats/goldenglory4.jpg").default,
      require("../img/boats/goldenglory5.jpg").default,
      require("../img/boats/goldenglory6.jpg").default,
      require("../img/boats/goldenglory7.jpg").default,
      require("../img/boats/goldenglory8.jpg").default,
      require("../img/boats/goldenglory9.jpg").default,
      require("../img/boats/goldenglory10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 83,
    category: "Goulet",
    name: "Gora",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: null,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: 3,
    crew: 6,
    length: 38.5,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, tüm kabin salon ve güvertede müzik sistemi, tv -uydu,Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Her kabinde mini bar, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, Buz makinesi, Kabinlerde servis telefonu, jetski, su kayağı ,kano",
    photo: require("../img/boats/gora.jpg").default,
    gallery: [
      require("../img/boats/gora1.jpg").default,
      require("../img/boats/gora2.jpg").default,
      require("../img/boats/gora3.jpg").default,
      require("../img/boats/gora4.jpg").default,
      require("../img/boats/gora5.jpg").default,
      require("../img/boats/gora6.jpg").default,
      require("../img/boats/gora7.jpg").default,
      require("../img/boats/gora8.jpg").default,
      require("../img/boats/gora9.jpg").default,
      require("../img/boats/gora10.jpg").default,
      require("../img/boats/gora11.jpg").default,
      require("../img/boats/gora12.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 84,
    category: "Goulet",
    name: "Gözdem I",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 26,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi,buz mak., şarap soğutucu, kahve mak., saç kurutma, 2 kano, su kayağı, 70hp joker bot",
    photo: require("../img/boats/gozdem.jpg").default,
    gallery: [
      require("../img/boats/gozdem1.jpg").default,
      require("../img/boats/gozdem2.jpg").default,
      require("../img/boats/gozdem3.jpg").default,
      require("../img/boats/gozdem4.jpg").default,
      require("../img/boats/gozdem5.jpg").default,
      require("../img/boats/gozdem6.jpg").default,
      require("../img/boats/gozdem7.jpg").default,
      require("../img/boats/gozdem8.jpg").default,
      require("../img/boats/gozdem9.jpg").default,
      require("../img/boats/gozdem10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 85,
    category: "Goulet",
    name: "Grand Lale",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: 3,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "joker servis  botu, kano",
    photo: require("../img/boats/grandlale.jpg").default,
    gallery: [
      require("../img/boats/grandlale1.jpg").default,
      require("../img/boats/grandlale2.jpg").default,
      require("../img/boats/grandlale3.jpg").default,
      require("../img/boats/grandlale4.jpg").default,
      require("../img/boats/grandlale5.jpg").default,
      require("../img/boats/grandlale6.jpg").default,
      require("../img/boats/grandlale7.jpg").default,
      require("../img/boats/grandlale8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 86,
    category: "Goulet",
    name: "Gul Maria",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: 1,
    crew: 6,
    length: 37,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, Buz makinesi,  Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, Kano, su kayağı, wakeboard, ringo, 100 hp joker bot",
    photo: require("../img/boats/gulmaria.jpg").default,
    gallery: [
      require("../img/boats/gulmaria1.jpg").default,
      require("../img/boats/gulmaria2.jpg").default,
      require("../img/boats/gulmaria3.jpg").default,
      require("../img/boats/gulmaria4.jpg").default,
      require("../img/boats/gulmaria5.jpg").default,
      require("../img/boats/gulmaria6.jpg").default,
      require("../img/boats/gulmaria7.jpg").default,
      require("../img/boats/gulmaria8.jpg").default,
      require("../img/boats/gulmaria9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 87,
    category: "Goulet",
    name: "Gusto",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 18,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano",
    photo: require("../img/boats/gusto.jpg").default,
    gallery: [
      require("../img/boats/gusto1.jpg").default,
      require("../img/boats/gusto2.jpg").default,
      require("../img/boats/gusto3.jpg").default,
      require("../img/boats/gusto4.jpg").default,
      require("../img/boats/gusto5.jpg").default,
      require("../img/boats/gusto6.jpg").default,
      require("../img/boats/gusto7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 88,
    category: "Yacht",
    name: "Halas 71",
    harbor: "İstanbul",
    capacity: 24,
    cabin: 12,
    masterCabin: 1,
    doubleCabin: 9,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 14,
    length: 54,
    width: 10,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Tam bir navigasyon ve iletişim donanımı. telefon, fax,boş zaman geçirme ve video odası, uzun bir bar, panoramik dnlenme bölümü, personal odaları ve oda servisi",
    photo: require("../img/boats/halas.jpg").default,
    gallery: [
      require("../img/boats/halas1.jpg").default,
      require("../img/boats/halas2.jpg").default,
      require("../img/boats/halas3.jpg").default,
      require("../img/boats/halas4.jpg").default,
      require("../img/boats/halas5.jpg").default,
      require("../img/boats/halas6.jpg").default,
      require("../img/boats/halas7.jpg").default,
      require("../img/boats/halas8.jpg").default,
      require("../img/boats/halas9.jpg").default,
      require("../img/boats/halas10.jpg").default,
      require("../img/boats/halas11.jpg").default,
      require("../img/boats/halas12.jpg").default,
      require("../img/boats/halas13.jpg").default,
      require("../img/boats/halas14.jpg").default,
      require("../img/boats/halas15.jpg").default,
      require("../img/boats/halas16.jpg").default,
      require("../img/boats/halas17.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 89,
    category: "Goulet",
    name: "Hasay",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 22,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve kabinlerde TV-Uydu, müzik sistemi,kano, kahve makinası, tüm navigasyon ekipmanları, kano",
    photo: require("../img/boats/hasay.jpg").default,
    gallery: [
      require("../img/boats/hasay1.jpg").default,
      require("../img/boats/hasay2.jpg").default,
      require("../img/boats/hasay3.jpg").default,
      require("../img/boats/hasay4.jpg").default,
      require("../img/boats/hasay5.jpg").default,
      require("../img/boats/hasay6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 90,
    category: "Goulet",
    name: "Hayal 62",
    harbor: "Bodrum",
    capacity: 4,
    cabin: 2,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 19,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Tüm seyir cihazları, Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, İnternet bağlantısı, güvertede müzik sistemi, kano",
    photo: require("../img/boats/hayal.jpg").default,
    gallery: [
      require("../img/boats/hayal1.jpg").default,
      require("../img/boats/hayal2.jpg").default,
      require("../img/boats/hayal3.jpg").default,
      require("../img/boats/hayal4.jpg").default,
      require("../img/boats/hayal5.jpg").default,
      require("../img/boats/hayal6.jpg").default,
      require("../img/boats/hayal7.jpg").default,
      require("../img/boats/hayal8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 91,
    category: "Goulet",
    name: "Hayalim D",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 5,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 7.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Tüm seyir cihazları, salon ve güvertede müzik sistemi, Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu",
    photo: require("../img/boats/hayalim.jpg").default,
    gallery: [
      require("../img/boats/hayalim1.jpg").default,
      require("../img/boats/hayalim2.jpg").default,
      require("../img/boats/hayalim3.jpg").default,
      require("../img/boats/hayalim4.jpg").default,
      require("../img/boats/hayalim5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 92,
    category: "Goulet",
    name: "Holiday V",
    harbor: "Fethiye",
    capacity: 20,
    cabin: 10,
    masterCabin: null,
    doubleCabin: 8,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 33,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda müzik sistemi , Klima, kano, rüzgar sörfü",
    photo: require("../img/boats/holiday.jpg").default,
    gallery: [
      require("../img/boats/holiday1.jpg").default,
      require("../img/boats/holiday2.jpg").default,
      require("../img/boats/holiday3.jpg").default,
      require("../img/boats/holiday4.jpg").default,
      require("../img/boats/holiday5.jpg").default,
      require("../img/boats/holiday6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 93,
    category: "Goulet",
    name: "Holiday 10",
    harbor: "Fethiye",
    capacity: 20,
    cabin: 10,
    masterCabin: 6,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 39,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "ringo, su kayağı, kano",
    photo: require("../img/boats/holidayon.jpg").default,
    gallery: [
      require("../img/boats/holidayon1.jpg").default,
      require("../img/boats/holidayon2.jpg").default,
      require("../img/boats/holidayon3.jpg").default,
      require("../img/boats/holidayon4.jpg").default,
      require("../img/boats/holidayon5.jpg").default,
      require("../img/boats/holidayon6.jpg").default,
      require("../img/boats/holidayon7.jpg").default,
      require("../img/boats/holidayon8.jpg").default,
      require("../img/boats/holidayon9.jpg").default,
      require("../img/boats/holidayon10.jpg").default,
      require("../img/boats/holidayon11.jpg").default,
      require("../img/boats/holidayon12.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 94,
    category: "Goulet",
    name: "Holiday VII",
    harbor: "Marmaris",
    capacity: 20,
    cabin: 10,
    masterCabin: null,
    doubleCabin: 10,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV & DVD & Müzik Sistemi",
    photo: require("../img/boats/holidayyedi.jpg").default,
    gallery: [
      require("../img/boats/holidayyedi1.jpg").default,
      require("../img/boats/holidayyedi2.jpg").default,
      require("../img/boats/holidayyedi3.jpg").default,
      require("../img/boats/holidayyedi4.jpg").default,
      require("../img/boats/holidayyedi5.jpg").default,
      require("../img/boats/holidayyedi6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 95,
    category: "Goulet",
    name: "Impact",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: 1,
    crew: 4,
    length: 26,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Elektronik harita, Tüm seyir cihazları, kabin ve salonda müzik sistemi, tv-uydu, Çay & Kahve makinesi, Türk karasularında internet bağlantısı, Saç kurutma makinesi, Salonda ve her kabinde CD & DVD oynatıcı, , Ringo, su kayağı, wake board, kano, ",
    photo: require("../img/boats/impact.jpg").default,
    gallery: [
      require("../img/boats/impact1.jpg").default,
      require("../img/boats/impact2.jpg").default,
      require("../img/boats/impact3.jpg").default,
      require("../img/boats/impact4.jpg").default,
      require("../img/boats/impact5.jpg").default,
      require("../img/boats/impact6.jpg").default,
      require("../img/boats/impact7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 96,
    category: "Goulet",
    name: "İsla",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon müzik sistemi,kano, kahve makinası, rüzgar sörfü, cd, dvd oynatıcı, tüm navigasyon ekipmanları",
    photo: require("../img/boats/isla.jpg").default,
    gallery: [
      require("../img/boats/isla1.jpg").default,
      require("../img/boats/isla2.jpg").default,
      require("../img/boats/isla3.jpg").default,
      require("../img/boats/isla4.jpg").default,
      require("../img/boats/isla5.jpg").default,
      require("../img/boats/isla6.jpg").default,
      require("../img/boats/isla7.jpg").default,
      require("../img/boats/isla8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 97,
    category: "Goulet",
    name: "Jasmin I",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Elektronik harita, Tüm seyir cihazları, salonda ve güvertede müzik sistemi,Buz makinesi, Kahve makinesi, Saç kurutma makinesi, kano",
    photo: require("../img/boats/jasmin.jpg").default,
    gallery: [
      require("../img/boats/jasmin1.jpg").default,
      require("../img/boats/jasmin2.jpg").default,
      require("../img/boats/jasmin3.jpg").default,
      require("../img/boats/jasmin4.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 98,
    category: "Goulet",
    name: "Junior Orçun",
    harbor: "Marmris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Müzik Sistemi, VHF Radio, DVD Player, her kabinde WC + duşakabin, kano, ringo, jetski ( Opsiyonel)j Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları, salonda tv, Kano, ringo, jet-ski (opsiyonel ), wake board ( opsiyonel)",
    photo: require("../img/boats/jrorcun.jpg").default,
    gallery: [
      require("../img/boats/jrorcun1.jpg").default,
      require("../img/boats/jrorcun2.jpg").default,
      require("../img/boats/jrorcun3.jpg").default,
      require("../img/boats/jrorcun4.jpg").default,
      require("../img/boats/jrorcun5.jpg").default,
      require("../img/boats/jrorcun6.jpg").default,
      require("../img/boats/jrorcun7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 99,
    category: "Goulet",
    name: "Kaptan Kadir",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 5,
    doubleCabin: null,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 39,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Mikrodalga fırın, Bulaşık makinesi, Kahve makinesi, Ekspresso, Filtre kahve makinesi, Şarap soğutucu, Su Yapıcı, Salonda ve tüm kabinlerde TV, DVD / CD oynatıcI, Müzik sistemi, tüm kabinlerde Minibar, BELİRTİLEN FİYATLARA HERŞEY DAHİL KONAKLAMA YAPILMAKTADIR. DELÜKS MENÜ + SICAK SOĞUK İÇECEKLER + YEREL ALKOLLÜ İÇECEKLER FİYATLARA DAHİLDİR. JET SKİ GÜNLÜK 200 EURO + YAKIT OLARAK ÜCRETLENDİRİLİR.",
    photo: require("../img/boats/kaptankadir.jpg").default,
    gallery: [
      require("../img/boats/kaptankadir1.jpg").default,
      require("../img/boats/kaptankadir2.jpg").default,
      require("../img/boats/kaptankadir3.jpg").default,
      require("../img/boats/kaptankadir4.jpg").default,
      require("../img/boats/kaptankadir5.jpg").default,
      require("../img/boats/kaptankadir6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 100,
    category: "Goulet",
    name: "Kaptan Yılmaz III",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: 4,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: 1,
    vipCabin: null,
    crew: 4,
    length: 33.5,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "DVD , TV müzik sistemi salonda  ,60 Hp dinghy",
    photo: require("../img/boats/katanyilmaz.jpg").default,
    gallery: [
      require("../img/boats/katanyilmaz1.jpg").default,
      require("../img/boats/katanyilmaz2.jpg").default,
      require("../img/boats/katanyilmaz3.jpg").default,
      require("../img/boats/katanyilmaz4.jpg").default,
      require("../img/boats/katanyilmaz5.jpg").default,
      require("../img/boats/katanyilmaz6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },

  {
    id: 101,
    category: "Goulet",
    name: "Karia",
    harbor: "Bodrum",
    capacity: 6,
    cabin: null,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 19,
    width: 6.1,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Dvd- Cd oynatıcı,  salonda müzik sistemi kano",
    photo: require("../img/boats/karia.jpg").default,
    gallery: [
      require("../img/boats/karia1.jpg").default,
      require("../img/boats/karia2.jpg").default,
      require("../img/boats/karia3.jpg").default,
      require("../img/boats/karia4.jpg").default,
      require("../img/boats/karia5.jpg").default,
      require("../img/boats/karia6.jpg").default,
      require("../img/boats/karia7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 102,
    category: "Goulet",
    name: "Karyalı",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda müzik sistemi, kano",
    photo: require("../img/boats/karyali.jpg").default,
    gallery: [
      require("../img/boats/karyali1.jpg").default,
      require("../img/boats/karyali2.jpg").default,
      require("../img/boats/karyali3.jpg").default,
      require("../img/boats/karyali4.jpg").default,
      require("../img/boats/karyali5.jpg").default,
      require("../img/boats/karyali6.jpg").default,
      require("../img/boats/karyali7.jpg").default,
      require("../img/boats/karyali8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 103,
    category: "Goulet",
    name: "Kaya Güneri I",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 7,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: 3,
    vipCabin: null,
    crew: 4,
    length: 26,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV müzik sistemi, 70 hp joker bot, rüzgar sörfü ve kano, su kayağı (opsiyonel)",
    photo: require("../img/boats/kayaguneri.jpg").default,
    gallery: [
      require("../img/boats/kayaguneri1.jpg").default,
      require("../img/boats/kayaguneri2.jpg").default,
      require("../img/boats/kayaguneri3.jpg").default,
      require("../img/boats/kayaguneri4.jpg").default,
      require("../img/boats/kayaguneri5.jpg").default,
      require("../img/boats/kayaguneri6.jpg").default,
      require("../img/boats/kayaguneri7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 104,
    category: "Goulet",
    name: "Kaya Güneri II",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: 4,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV, DVD, CD,  joker bot, rüzgar sörfü, 2 kano, su kayağı",
    photo: require("../img/boats/kayaguneriki.jpg").default,
    gallery: [
      require("../img/boats/kayaguneriki1.jpg").default,
      require("../img/boats/kayaguneriki2.jpg").default,
      require("../img/boats/kayaguneriki3.jpg").default,
      require("../img/boats/kayaguneriki4.jpg").default,
      require("../img/boats/kayaguneriki5.jpg").default,
      require("../img/boats/kayaguneriki6.jpg").default,
      require("../img/boats/kayaguneriki7.jpg").default,
      require("../img/boats/kayaguneriki8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 105,
    category: "Goulet",
    name: "Kaya Güneri III",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 29,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Servis botu, kano, balık tutma malzemeleri ve snorkel, palet",
    photo: require("../img/boats/kayaguneriuc.jpg").default,
    gallery: [
      require("../img/boats/kayaguneriuc1.jpg").default,
      require("../img/boats/kayaguneriuc2.jpg").default,
      require("../img/boats/kayaguneriuc3.jpg").default,
      require("../img/boats/kayaguneriuc4.jpg").default,
      require("../img/boats/kayaguneriuc5.jpg").default,
      require("../img/boats/kayaguneriuc6.jpg").default,
      require("../img/boats/kayaguneriuc7.jpg").default,
      require("../img/boats/kayaguneriuc8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 106,
    category: "Goulet",
    name: "Kaya Güneri IV",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 34,
    width: 8,
    other:
      "Kabin ve salonda DVD, TV, güvertede müzik sistemi, tüm kabinlerde TV/DVD, internet, su kayağı, ringo, paddle board, rüzgar sörfü, banana, kano, 100 hp motor bot",
    photo: require("../img/boats/kayaguneridort.jpg").default,
    gallery: [
      require("../img/boats/kayaguneridort1.jpg").default,
      require("../img/boats/kayaguneridort2.jpg").default,
      require("../img/boats/kayaguneridort3.jpg").default,
      require("../img/boats/kayaguneridort4.jpg").default,
      require("../img/boats/kayaguneridort5.jpg").default,
      require("../img/boats/kayaguneridort6.jpg").default,
      require("../img/boats/kayaguneridort7.jpg").default,
      require("../img/boats/kayaguneridort8.jpg").default,
      require("../img/boats/kayaguneridort9.jpg").default,
      require("../img/boats/kayaguneridort10.jpg").default,
      require("../img/boats/kayaguneridort11.jpg").default,
      require("../img/boats/kayaguneridort12.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 107,
    category: "Goulet",
    name: "Kaya Güneri V",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 39,
    width: 9.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabin ve salonda DVD, TV, güvertede müzik sistemi, tüm kabinlerde TV/DVD, internet, 100 hp joker bot, mono ve solo su kayağı, ringo, paddle board, rüzgar sörfü, banana, kano, jet ski",
    photo: require("../img/boats/kayaguneribes.jpg").default,
    gallery: [
      require("../img/boats/kayaguneribes1.jpg").default,
      require("../img/boats/kayaguneribes2.jpg").default,
      require("../img/boats/kayaguneribes3.jpg").default,
      require("../img/boats/kayaguneribes4.jpg").default,
      require("../img/boats/kayaguneribes5.jpg").default,
      require("../img/boats/kayaguneribes6.jpg").default,
      require("../img/boats/kayaguneribes7.jpg").default,
      require("../img/boats/kayaguneribes8.jpg").default,
      require("../img/boats/kayaguneribes9.jpg").default,
      require("../img/boats/kayaguneribes10.jpg").default,
      require("../img/boats/kayaguneribes11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 108,
    category: "Goulet",
    name: "Kaya Güneri Plus",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 6,
    length: 34,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler, salon ve güvertede, tüm kabinlerde duşakabin, TV- uydu, Haberleşme cihazı, Derinlik ölçer, Radar, GPS, Pusula, Uydu haberleşme cihazı, Otopilot, Elektronik harita, Tüm seyir cihazları,Buz makinesi, Kahve makinesi, Şarap soğutucu, Saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı, Her kabinde kilitli kasa, 80 HP motor bot, kano ve su kayağı",
    photo: require("../img/boats/kayaguneriplus.jpg").default,
    gallery: [
      require("../img/boats/kayaguneriplus1.jpg").default,
      require("../img/boats/kayaguneriplus2.jpg").default,
      require("../img/boats/kayaguneriplus3.jpg").default,
      require("../img/boats/kayaguneriplus4.jpg").default,
      require("../img/boats/kayaguneriplus5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 109,
    category: "Yacht",
    name: "Kayhan 5",
    harbor: "Fethiye",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Şarap soğutucu, buz makinası, kahve makinası, 2 kano, motorlu su sporları opsiyonel",
    photo: require("../img/boats/kayhanbes.jpg").default,
    gallery: [
      require("../img/boats/kayhanbes1.jpg").default,
      require("../img/boats/kayhanbes2.jpg").default,
      require("../img/boats/kayhanbes3.jpg").default,
      require("../img/boats/kayhanbes4.jpg").default,
      require("../img/boats/kayhanbes5.jpg").default,
      require("../img/boats/kayhanbes6.jpg").default,
      require("../img/boats/kayhanbes7.jpg").default,
      require("../img/boats/kayhanbes8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 110,
    category: "Goulet",
    name: "Kim Bu",
    harbor: "Marmaris",
    capacity: 14,
    cabin: 7,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 7.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda CD Oynatıcı, DVD Oynatıcı, kahve makinesi, şarap soğutucu,, kano ve servis botu",
    photo: require("../img/boats/kimbu.jpg").default,
    gallery: [
      require("../img/boats/kimbu1.jpg").default,
      require("../img/boats/kimbu2.jpg").default,
      require("../img/boats/kimbu3.jpg").default,
      require("../img/boats/kimbu4.jpg").default,
      require("../img/boats/kimbu5.jpg").default,
      require("../img/boats/kimbu6.jpg").default,
      require("../img/boats/kimbu7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 111,
    category: "Goulet",
    name: "Kurt K",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: 3,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 31,
    width: 7.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Tüm kabinlerde duşakabin ve saç kurutma makinası, Salonda Tv ve DVD oynatıcı, müzik sistemi, çamaşır ve bulaşık makinası, tüm kabinlerde klima, su kayağı, ve kano, Türk sularında internet bağlantısı",
    photo: require("../img/boats/kurtk.jpg").default,
    gallery: [
      require("../img/boats/kurtk1.jpg").default,
      require("../img/boats/kurtk2.jpg").default,
      require("../img/boats/kurtk3.jpg").default,
      require("../img/boats/kurtk4.jpg").default,
      require("../img/boats/kurtk5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 112,
    category: "Goulet",
    name: "Lorient",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 10,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Tüm seyir cihazlar salon ve kabinlerde tv-uydu, salon ve güvertede müzik sistemi, kahve makinesi, şarap soğutucu, kabinlerde servis telefonu, Türk sularında internet bağlantısı, saç kurutma makinesi, her kabinde kilitli kasa, Salonda ve her kabinde CD - DVD oynatıcı, 2 adet kano, sörf ve su kayağı, 75 hp motor bot",
    photo: require("../img/boats/lorient.jpg").default,
    gallery: [
      require("../img/boats/lorient1.jpg").default,
      require("../img/boats/lorient2.jpg").default,
      require("../img/boats/lorient3.jpg").default,
      require("../img/boats/lorient4.jpg").default,
      require("../img/boats/lorient5.jpg").default,
      require("../img/boats/lorient6.jpg").default,
      require("../img/boats/lorient7.jpg").default,
      require("../img/boats/lorient8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 113,
    category: "Goulet",
    name: "Laguna",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 12,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 25,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV ve müzik sistemi, kahve makinası, kano",
    photo: require("../img/boats/laguna.jpg").default,
    gallery: [
      require("../img/boats/laguna1.jpg").default,
      require("../img/boats/laguna2.jpg").default,
      require("../img/boats/laguna3.jpg").default,
      require("../img/boats/laguna4.jpg").default,
      require("../img/boats/laguna5.jpg").default,
      require("../img/boats/laguna6.jpg").default,
      require("../img/boats/laguna7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 114,
    category: "Goulet",
    name: "Laila Deniz",
    harbor: "Marmaris",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21.6,
    width: 5.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, filtre kahve makinesi,Servis botu, kano, balık tutma ekipmanları, maske palet snorkel",
    photo: require("../img/boats/lailadeniz.jpg").default,
    gallery: [
      require("../img/boats/lailadeniz1.jpg").default,
      require("../img/boats/lailadeniz2.jpg").default,
      require("../img/boats/lailadeniz3.jpg").default,
      require("../img/boats/lailadeniz4.jpg").default,
      require("../img/boats/lailadeniz5.jpg").default,
      require("../img/boats/lailadeniz6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 115,
    category: "Goulet",
    name: "Laram",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 18,
    width: 5.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, filtre kahve makinesi, servis botu, kano, balık tutma ekipmanları",
    photo: require("../img/boats/laram.jpg").default,
    gallery: [
      require("../img/boats/laram1.jpg").default,
      require("../img/boats/laram2.jpg").default,
      require("../img/boats/laram3.jpg").default,
      require("../img/boats/laram4.jpg").default,
      require("../img/boats/laram5.jpg").default,
      require("../img/boats/laram6.jpg").default,
      require("../img/boats/laram7.jpg").default,
      require("../img/boats/laram8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 116,
    category: "Goulet",
    name: "Levent Kaptan 1",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 3,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 28,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi, kahve makinesi, CD Oynatıcı, DVD Oynatıcı",
    photo: require("../img/boats/leventkaptan.jpg").default,
    gallery: [
      require("../img/boats/leventkaptan1.jpg").default,
      require("../img/boats/leventkaptan2.jpg").default,
      require("../img/boats/leventkaptan3.jpg").default,
      require("../img/boats/leventkaptan4.jpg").default,
      require("../img/boats/leventkaptan5.jpg").default,
      require("../img/boats/leventkaptan6.jpg").default,
      require("../img/boats/leventkaptan7.jpg").default,
      require("../img/boats/leventkaptan8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 117,
    category: "Yacht",
    name: "Luce Del Mare",
    harbor: "Fethiye",
    capacity: 12,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 5,
    length: 37,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD - DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, kano",
    photo: require("../img/boats/lucedelmare.jpg").default,
    gallery: [
      require("../img/boats/lucedelmare1.jpg").default,
      require("../img/boats/lucedelmare2.jpg").default,
      require("../img/boats/lucedelmare3.jpg").default,
      require("../img/boats/lucedelmare4.jpg").default,
      require("../img/boats/lucedelmare5.jpg").default,
      require("../img/boats/lucedelmare6.jpg").default,
      require("../img/boats/lucedelmare7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 118,
    category: "Goulet",
    name: "Lycian Queen",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: 1,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: 1,
    crew: 5,
    length: 37,
    width: 9.75,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD CD oynatıcı, müzik sistemi, kano, rüzgar sörfü, kahve makinası, buz makinası, IPAD stereo müzik sistemi, türk kara sularında wifi bağlantısı,2 paddle board",
    photo: require("../img/boats/lycianqueen.jpg").default,
    gallery: [
      require("../img/boats/lycianqueen1.jpg").default,
      require("../img/boats/lycianqueen2.jpg").default,
      require("../img/boats/lycianqueen3.jpg").default,
      require("../img/boats/lycianqueen4.jpg").default,
      require("../img/boats/lycianqueen5.jpg").default,
      require("../img/boats/lycianqueen6.jpg").default,
      require("../img/boats/lycianqueen7.jpg").default,
      require("../img/boats/lycianqueen8.jpg").default,
      require("../img/boats/lycianqueen9.jpg").default,
      require("../img/boats/lycianqueen10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 119,
    category: "Goulet",
    name: "Mare Nostrum",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 5,
    doubleCabin: null,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 7,
    length: 43,
    width: 8.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, saç kurutma makinesi, CD - DVD oynatıcı, kano, rüzgar sörfü, su kayağı, ringo, banana, knee board, 70 Hp joker bot, paddle, Jetski extra",
    photo: require("../img/boats/marenostrum.jpg").default,
    gallery: [
      require("../img/boats/marenostrum1.jpg").default,
      require("../img/boats/marenostrum2.jpg").default,
      require("../img/boats/marenostrum3.jpg").default,
      require("../img/boats/marenostrum4.jpg").default,
      require("../img/boats/marenostrum5.jpg").default,
      require("../img/boats/marenostrum6.jpg").default,
      require("../img/boats/marenostrum7.jpg").default,
      require("../img/boats/marenostrum8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 120,
    category: "Goulet",
    name: "Mehmet Ayaz",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24.4,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinası, kahve makinası, servis botu, 2 kano, su kayağı, ringo, balık tutmak için ekipmanlar",
    photo: require("../img/boats/mehmetayaz.jpg").default,
    gallery: [
      require("../img/boats/mehmetayaz1.jpg").default,
      require("../img/boats/mehmetayaz2.jpg").default,
      require("../img/boats/mehmetayaz3.jpg").default,
      require("../img/boats/mehmetayaz4.jpg").default,
      require("../img/boats/mehmetayaz5.jpg").default,
      require("../img/boats/mehmetayaz6.jpg").default,
      require("../img/boats/mehmetayaz7.jpg").default,
      require("../img/boats/mehmetayaz8.jpg").default,
      require("../img/boats/mehmetayaz9.jpg").default,
      require("../img/boats/mehmetayaz10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  // {
  //   id: 121,
  //   category: "Goulet",
  //   name: "Maske",
  //   harbor: "Fethiye",
  //   capacity: 10,
  //   cabin: 5,
  //   masterCabin: 1,
  //   doubleCabin: 2,
  //   twinCabin: null,
  //   tripleCabin: null,
  //   vipCabin: 2,
  //   crew: 3,
  //   length: 24,
  //   width: 6.8,
  //   equipments:
  //     "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
  //   other:
  //     "Kabinler, salon ve güvertede TV-Uydu müzik sistemi, buz makinesi, kahve makinesi, şarap soğutucu, internet bağlantısı, saç kurutma makinesi, kano",
  // },
  {
    id: 122,
    category: "Goulet",
    name: "Mehmet Buğra",
    harbor: "Marmaris",
    capacity: 18,
    cabin: 8,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 6,
    length: 34,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, USB girişi salon ve kabinlerde, HDMI girişi salon ve kabinlerde,buz yapıcı, derin dondurucu, espresso ve filtre makinası, tam donanımlı yelken, jet ski extra opsiyonel,  su kayağı, mono ski, wakeboard, kneeboard, paddle board, kayaks, banana ve ringo",
    photo: require("../img/boats/mehmetbugra.jpg").default,
    gallery: [
      require("../img/boats/mehmetbugra1.jpg").default,
      require("../img/boats/mehmetbugra2.jpg").default,
      require("../img/boats/mehmetbugra3.jpg").default,
      require("../img/boats/mehmetbugra4.jpg").default,
      require("../img/boats/mehmetbugra5.jpg").default,
      require("../img/boats/mehmetbugra6.jpg").default,
      require("../img/boats/mehmetbugra7.jpg").default,
      require("../img/boats/mehmetbugra8.jpg").default,
      require("../img/boats/mehmetbugra9.jpg").default,
      require("../img/boats/mehmetbugra10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 123,
    category: "Yacht",
    name: "Merve",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 35,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "90 hp joker bot, su kayağı, ringo, güvertede jakuzzi, salon ve güvertede müzik sistemi, Türk kara sularında internet",
    photo: require("../img/boats/merve.jpg").default,
    gallery: [
      require("../img/boats/merve1.jpg").default,
      require("../img/boats/merve2.jpg").default,
      require("../img/boats/merve3.jpg").default,
      require("../img/boats/merve4.jpg").default,
      require("../img/boats/merve5.jpg").default,
      require("../img/boats/merve6.jpg").default,
      require("../img/boats/merve7.jpg").default,
      require("../img/boats/merve8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 124,
    category: "Goulet",
    name: "Mezcal II",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 38,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, saç kurutma makinesi, salonda ve her kabinde CD - DVD oynatıcıve müzik sistemi, kano, rüzgar sörfü, su kayağı, wakeboard, ringo, banana",
    photo: require("../img/boats/mezcal.jpg").default,
    gallery: [
      require("../img/boats/mezcal1.jpg").default,
      require("../img/boats/mezcal2.jpg").default,
      require("../img/boats/mezcal3.jpg").default,
      require("../img/boats/mezcal4.jpg").default,
      require("../img/boats/mezcal5.jpg").default,
      require("../img/boats/mezcal6.jpg").default,
      require("../img/boats/mezcal7.jpg").default,
      require("../img/boats/mezcal8.jpg").default,
      require("../img/boats/mezcal9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 125,
    category: "Goulet",
    name: "Mikado",
    harbor: "Marmaris",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 26.6,
    width: 6.45,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda müzik sistemi, CD Oynatıcı, DVD Oynatıcı, kahve makinesi, şarap soğutucu, kano",
    photo: require("../img/boats/mikado.jpg").default,
    gallery: [
      require("../img/boats/mikado1.jpg").default,
      require("../img/boats/mikado2.jpg").default,
      require("../img/boats/mikado3.jpg").default,
      require("../img/boats/mikado4.jpg").default,
      require("../img/boats/mikado5.jpg").default,
      require("../img/boats/mikado6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 126,
    category: "Goulet",
    name: "Miss B",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: 1,
    crew: 4,
    length: 29,
    width: 7.15,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, saç kurutma makinesi",
    photo: require("../img/boats/missb.jpg").default,
    gallery: [
      require("../img/boats/missb1.jpg").default,
      require("../img/boats/missb2.jpg").default,
      require("../img/boats/missb3.jpg").default,
      require("../img/boats/missb4.jpg").default,
      require("../img/boats/missb5.jpg").default,
      require("../img/boats/missb6.jpg").default,
      require("../img/boats/missb7.jpg").default,
      require("../img/boats/missb8.jpg").default,
      require("../img/boats/missb9.jpg").default,
      require("../img/boats/missb10.jpg").default,
      require("../img/boats/missb11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 127,
    category: "Goulet",
    name: "Motif",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 33,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Müzik sistemi salon ve güvertede, saç kurutma makinası, kahve makinası, güvertede jakuzi, kano, rüzgar sörfü",
    photo: require("../img/boats/motif.jpg").default,
    gallery: [
      require("../img/boats/motif1.jpg").default,
      require("../img/boats/motif2.jpg").default,
      require("../img/boats/motif3.jpg").default,
      require("../img/boats/motif4.jpg").default,
      require("../img/boats/motif5.jpg").default,
      require("../img/boats/motif6.jpg").default,
      require("../img/boats/motif7.jpg").default,
      require("../img/boats/motif8.jpg").default,
      require("../img/boats/motif9.jpg").default,
      require("../img/boats/motif10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 128,
    category: "Goulet",
    name: "Moonstar",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 25,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, kahve makinesi, şarap soğutucu, internet bağlantısı, kano",
    photo: require("../img/boats/moonstar.jpg").default,
    gallery: [
      require("../img/boats/moonstar1.jpg").default,
      require("../img/boats/moonstar2.jpg").default,
      require("../img/boats/moonstar3.jpg").default,
      require("../img/boats/moonstar4.jpg").default,
      require("../img/boats/moonstar5.jpg").default,
      require("../img/boats/moonstar6.jpg").default,
      require("../img/boats/moonstar7.jpg").default,
      require("../img/boats/moonstar8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 129,
    category: "Goulet",
    name: "Mutlu Kaptan",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, kahve makinesi, şarap soğutucu,saç kurutma makinası, kano",
    photo: require("../img/boats/mutlukaptan.jpg").default,
    gallery: [
      require("../img/boats/mutlukaptan1.jpg").default,
      require("../img/boats/mutlukaptan2.jpg").default,
      require("../img/boats/mutlukaptan3.jpg").default,
      require("../img/boats/mutlukaptan4.jpg").default,
      require("../img/boats/mutlukaptan5.jpg").default,
      require("../img/boats/mutlukaptan6.jpg").default,
      require("../img/boats/mutlukaptan7.jpg").default,
      require("../img/boats/mutlukaptan8.jpg").default,
      require("../img/boats/mutlukaptan9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 130,
    category: "Yacht",
    name: "My Tutku",
    harbor: "Göcek",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: 2,
    crew: 5,
    length: 34,
    width: 7.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, salonda TV ve müzik sistemi, kahve makinesi, şarap soğutucu,saç kurutma makinası",
    photo: require("../img/boats/mytutku.jpg").default,
    gallery: [
      require("../img/boats/mytutku1.jpg").default,
      require("../img/boats/mytutku2.jpg").default,
      require("../img/boats/mytutku3.jpg").default,
      require("../img/boats/mytutku4.jpg").default,
      require("../img/boats/mytutku5.jpg").default,
      require("../img/boats/mytutku6.jpg").default,
      require("../img/boats/mytutku7.jpg").default,
      require("../img/boats/mytutku8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 131,
    category: "Goulet",
    name: "Nagehan",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 15,
    width: 4.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Olta takımları, snorkel ve palet",
    photo: require("../img/boats/nagehan.jpg").default,
    gallery: [
      require("../img/boats/nagehan1.jpg").default,
      require("../img/boats/nagehan2.jpg").default,
      require("../img/boats/nagehan3.jpg").default,
      require("../img/boats/nagehan4.jpg").default,
      require("../img/boats/nagehan5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 132,
    category: "Goulet",
    name: "Nautilus",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 37,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD & Müzik Sistemi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, ringo, su kayağı",
    photo: require("../img/boats/nautilus.jpg").default,
    gallery: [
      require("../img/boats/nautilus1.jpg").default,
      require("../img/boats/nautilus2.jpg").default,
      require("../img/boats/nautilus3.jpg").default,
      require("../img/boats/nautilus4.jpg").default,
      require("../img/boats/nautilus5.jpg").default,
      require("../img/boats/nautilus6.jpg").default,
      require("../img/boats/nautilus7.jpg").default,
      require("../img/boats/nautilus8.jpg").default,
      require("../img/boats/nautilus9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 133,
    category: "Goulet",
    name: "Nazcan",
    harbor: "Bodrum",
    capacity: 4,
    cabin: 2,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 15,
    width: 4.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kahve makinesi, olta takımı, snorkel, palet",
    photo: require("../img/boats/nazcan.jpg").default,
    gallery: [
      require("../img/boats/nazcan1.jpg").default,
      require("../img/boats/nazcan2.jpg").default,
      require("../img/boats/nazcan3.jpg").default,
      require("../img/boats/nazcan4.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 134,
    category: "Goulet",
    name: "Neptün",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 5.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kahve makinesi, olta takımı, snorkel takım, buz makinesi, kahve makinesi, filtre kahve makinesi, servis botu, 1 adet kano",
    photo: require("../img/boats/neptun.jpg").default,
    gallery: [
      require("../img/boats/neptun1.jpg").default,
      require("../img/boats/neptun2.jpg").default,
      require("../img/boats/neptun3.jpg").default,
      require("../img/boats/neptun4.jpg").default,
      require("../img/boats/neptun5.jpg").default,
      require("../img/boats/neptun6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 135,
    category: "Goulet",
    name: "Nostalgia",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 5.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano, rüzgar sörfü,  ringo, 40 hp joker bo adet kano",
    photo: require("../img/boats/nostalgia.jpg").default,
    gallery: [
      require("../img/boats/nostalgia1.jpg").default,
      require("../img/boats/nostalgia2.jpg").default,
      require("../img/boats/nostalgia3.jpg").default,
      require("../img/boats/nostalgia4.jpg").default,
      require("../img/boats/nostalgia5.jpg").default,
      require("../img/boats/nostalgia6.jpg").default,
      require("../img/boats/nostalgia7.jpg").default,
      require("../img/boats/nostalgia8.jpg").default,
      require("../img/boats/nostalgia9.jpg").default,
      require("../img/boats/nostalgia10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 136,
    category: "Goulet",
    name: "Nurten A",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: 2,
    crew: 3,
    length: 31,
    width: 7.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kahve makinesi, Türk karasularında internet bağlantısı, saç kurutma makinesi, salonda ve kabinlerde müzk sistemi, tv, dvd oynatıcı, Kano, Rüzgar sörfü, su kayağı. BELİRTİLEN FİYATLARA HER ŞEY DAHİL KONAKLAMA YAPILMAKTADIR. DELÜKS MENÜ + SICAK SOĞUK İÇECEKLER + YEREL ALKOLLÜ İÇECEKLER FİYATLARA DAHİLDİR.",
    photo: require("../img/boats/nurten.jpg").default,
    gallery: [
      require("../img/boats/nurten1.jpg").default,
      require("../img/boats/nurten2.jpg").default,
      require("../img/boats/nurten3.jpg").default,
      require("../img/boats/nurten4.jpg").default,
      require("../img/boats/nurten5.jpg").default,
      require("../img/boats/nurten6.jpg").default,
      require("../img/boats/nurten7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 137,
    category: "Goulet",
    name: "Oğuz Bey",
    harbor: "Bodrum",
    capacity: 22,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: 6,
    vipCabin: null,
    crew: 3,
    length: 32,
    width: 7.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Servis botu 115 HP, 2 kano, banana, su kayağı, ringo, paddle board, internet Türkkara sularında, Balık tutma ekipmanları, maske, palet, şnorkel",
    photo: require("../img/boats/oguzbey.jpg").default,
    gallery: [
      require("../img/boats/oguzbey1.jpg").default,
      require("../img/boats/oguzbey2.jpg").default,
      require("../img/boats/oguzbey3.jpg").default,
      require("../img/boats/oguzbey4.jpg").default,
      require("../img/boats/oguzbey5.jpg").default,
      require("../img/boats/oguzbey6.jpg").default,
      require("../img/boats/oguzbey7.jpg").default,
      require("../img/boats/oguzbey8.jpg").default,
      require("../img/boats/oguzbey9.jpg").default,
      require("../img/boats/oguzbey10.jpg").default,
      require("../img/boats/oguzbey11.jpg").default,
      require("../img/boats/oguzbey12.jpg").default,
      require("../img/boats/oguzbey13.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 138,
    category: "Goulet",
    name: "Oğuzhan",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 1,
    tripleCabin: 1,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Ipad bağlantısı, kasa, servis botu 70 hp",
    photo: require("../img/boats/oguzhan.jpg").default,
    gallery: [
      require("../img/boats/oguzhan1.jpg").default,
      require("../img/boats/oguzhan2.jpg").default,
      require("../img/boats/oguzhan3.jpg").default,
      require("../img/boats/oguzhan4.jpg").default,
      require("../img/boats/oguzhan5.jpg").default,
      require("../img/boats/oguzhan6.jpg").default,
      require("../img/boats/oguzhan7.jpg").default,
      require("../img/boats/oguzhan8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 139,
    category: "Goulet",
    name: "One Star",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: 1,
    doubleCabin: 5,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi, saç kurutma makinesi, salonda lcd TV",
    photo: require("../img/boats/onestar.jpg").default,
    gallery: [
      require("../img/boats/onestar1.jpg").default,
      require("../img/boats/onestar2.jpg").default,
      require("../img/boats/onestar3.jpg").default,
      require("../img/boats/onestar4.jpg").default,
      require("../img/boats/onestar5.jpg").default,
      require("../img/boats/onestar6.jpg").default,
      require("../img/boats/onestar7.jpg").default,
      require("../img/boats/onestar8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 140,
    category: "Goulet",
    name: "Osman Kurt",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: 2,
    vipCabin: null,
    crew: 4,
    length: 31,
    width: 7.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve güvertede müzik sistemi, tüm banyolarda duşakabin yurt dışı çıkış kapasitesi 16 kişidir, kahve ve buz makinası",
    photo: require("../img/boats/osmankurt.jpg").default,
    gallery: [
      require("../img/boats/osmankurt1.jpg").default,
      require("../img/boats/osmankurt2.jpg").default,
      require("../img/boats/osmankurt3.jpg").default,
      require("../img/boats/osmankurt4.jpg").default,
      require("../img/boats/osmankurt5.jpg").default,
      require("../img/boats/osmankurt6.jpg").default,
      require("../img/boats/osmankurt7.jpg").default,
      require("../img/boats/osmankurt8.jpg").default,
      require("../img/boats/osmankurt9.jpg").default,
      require("../img/boats/osmankurt10.jpg").default,
      require("../img/boats/osmankurt11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 141,
    category: "Goulet",
    name: "Papa Joe",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 33.8,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Şarap soğutucu, derin dondurucu, buz makinesi, kahve makinesi, filtre kahve makinesi, espresso makinesi, servis botu, 2 adet 2 kişilik kano, rüzgar sörfü, 1 yetişkin su kayağı, 1 çocuk su kayağı, wakeboard, mono board, 3 ringo, 2 paddle board",
    photo: require("../img/boats/papajoe.jpg").default,
    gallery: [
      require("../img/boats/papajoe1.jpg").default,
      require("../img/boats/papajoe2.jpg").default,
      require("../img/boats/papajoe3.jpg").default,
      require("../img/boats/papajoe4.jpg").default,
      require("../img/boats/papajoe5.jpg").default,
      require("../img/boats/papajoe6.jpg").default,
      require("../img/boats/papajoe7.jpg").default,
      require("../img/boats/papajoe8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 142,
    category: "Goulet",
    name: "Pavurya",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 18,
    width: 5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz ve kahve makinası, 2 kabinde pompalı WC mevcut",
    photo: require("../img/boats/pavurya.jpg").default,
    gallery: [
      require("../img/boats/pavurya1.jpg").default,
      require("../img/boats/pavurya2.jpg").default,
      require("../img/boats/pavurya3.jpg").default,
      require("../img/boats/pavurya4.jpg").default,
      require("../img/boats/pavurya5.jpg").default,
      require("../img/boats/pavurya6.jpg").default,
      require("../img/boats/pavurya7.jpg").default,
      require("../img/boats/pavurya8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 143,
    category: "Goulet",
    name: "Perla Del Mare",
    harbor: "Antalya",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 7,
    length: 42,
    width: 9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD-DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, her kabinde CD DVD oynatıcı, servis botu, tam donanımlı yelken, güvrtede jakuzzi",
    photo: require("../img/boats/perledelmare.jpg").default,
    gallery: [
      require("../img/boats/perledelmare1.jpg").default,
      require("../img/boats/perledelmare2.jpg").default,
      require("../img/boats/perledelmare3.jpg").default,
      require("../img/boats/perledelmare4.jpg").default,
      require("../img/boats/perledelmare5.jpg").default,
      require("../img/boats/perledelmare6.jpg").default,
      require("../img/boats/perledelmare7.jpg").default,
      require("../img/boats/perledelmare8.jpg").default,
      require("../img/boats/perledelmare9.jpg").default,
      require("../img/boats/perledelmare10.jpg").default,
      require("../img/boats/perledelmare11.jpg").default,
      require("../img/boats/perledelmare12.jpg").default,
      require("../img/boats/perledelmare13.jpg").default,
      require("../img/boats/perledelmare14.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 144,
    category: "Goulet",
    name: "Perrinita",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Servis botu, kahve makinası, buz makinası",
    photo: require("../img/boats/perrinita.jpg").default,
    gallery: [
      require("../img/boats/perrinita1.jpg").default,
      require("../img/boats/perrinita2.jpg").default,
      require("../img/boats/perrinita3.jpg").default,
      require("../img/boats/perrinita4.jpg").default,
      require("../img/boats/perrinita5.jpg").default,
      require("../img/boats/perrinita6.jpg").default,
      require("../img/boats/perrinita7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 145,
    category: "Goulet",
    name: "Pınar 111",
    harbor: "Fethiye",
    capacity: 32,
    cabin: 16,
    masterCabin: null,
    doubleCabin: 10,
    twinCabin: 4,
    tripleCabin: 2,
    vipCabin: null,
    crew: 5,
    length: 33,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi, CD-DVD Oynatıcı, kano, su kayağı, knee board, sörf",
    photo: require("../img/boats/pinar.jpg").default,
    gallery: [
      require("../img/boats/pinar1.jpg").default,
      require("../img/boats/pinar2.jpg").default,
      require("../img/boats/pinar3.jpg").default,
      require("../img/boats/pinar4.jpg").default,
      require("../img/boats/pinar5.jpg").default,
      require("../img/boats/pinar6.jpg").default,
      require("../img/boats/pinar7.jpg").default,
      require("../img/boats/pinar8.jpg").default,
      require("../img/boats/pinar9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 146,
    category: "Goulet",
    name: "Prenses Lila",
    harbor: "Fethiye",
    capacity: 18,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 4,
    length: 36,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salon ve güvertede müzik sistemi, Servis botu, 70 hp joker bot, 2 kano, rüzgar sörfü, ringo, su kayağı, snorkel ve olta takımı",
    photo: require("../img/boats/prenseslina.jpg").default,
    gallery: [
      require("../img/boats/prenseslina1.jpg").default,
      require("../img/boats/prenseslina2.jpg").default,
      require("../img/boats/prenseslina3.jpg").default,
      require("../img/boats/prenseslina4.jpg").default,
      require("../img/boats/prenseslina5.jpg").default,
      require("../img/boats/prenseslina6.jpg").default,
      require("../img/boats/prenseslina7.jpg").default,
      require("../img/boats/prenseslina8.jpg").default,
      require("../img/boats/prenseslina9.jpg").default,
      require("../img/boats/prenseslina10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 147,
    category: "Goulet",
    name: "Prenses Selin",
    harbor: "Fethiye",
    capacity: 20,
    cabin: 9,
    masterCabin: null,
    doubleCabin: 7,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 5,
    length: 37,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Servis botu, ringo, su kayağı,kano, rüzgar sörfü, snorkel ve olta takımı",
    photo: require("../img/boats/prensesselin.jpg").default,
    gallery: [
      require("../img/boats/prensesselin1.jpg").default,
      require("../img/boats/prensesselin2.jpg").default,
      require("../img/boats/prensesselin3.jpg").default,
      require("../img/boats/prensesselin4.jpg").default,
      require("../img/boats/prensesselin5.jpg").default,
      require("../img/boats/prensesselin6.jpg").default,
      require("../img/boats/prensesselin7.jpg").default,
      require("../img/boats/prensesselin8.jpg").default,
      require("../img/boats/prensesselin9.jpg").default,
      require("../img/boats/prensesselin10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 148,
    category: "Goulet",
    name: "Primadonna",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 3,
    doubleCabin: null,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21,
    width: 5.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, Kahve makinesi, şarap soğutucu, internet bağlantısı, saç kurutma makinesi, salon ve güvertede müzik sistemi, salonda tv-uydu, kano, 2 adet ringo, su kayağı",
    photo: require("../img/boats/primadonna.jpg").default,
    gallery: [
      require("../img/boats/primadonna1.jpg").default,
      require("../img/boats/primadonna2.jpg").default,
      require("../img/boats/primadonna3.jpg").default,
      require("../img/boats/primadonna4.jpg").default,
      require("../img/boats/primadonna5.jpg").default,
      require("../img/boats/primadonna6.jpg").default,
      require("../img/boats/primadonna7.jpg").default,
      require("../img/boats/primadonna8.jpg").default,
      require("../img/boats/primadonna9.jpg").default,
      require("../img/boats/primadonna10.jpg").default,
      require("../img/boats/primadonna11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 149,
    category: "Goulet",
    name: "Queen Atlantis",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 36,
    width: 8.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV - DVD oynatıcı, tüm kabinlerde duşakabin, saç kurutma makinesi, buz yapıcı, internet türk kara sularında, LCD cinema sistemi, saç kurutucu",
    photo: require("../img/boats/queenatlantis.jpg").default,
    gallery: [
      require("../img/boats/queenatlantis1.jpg").default,
      require("../img/boats/queenatlantis2.jpg").default,
      require("../img/boats/queenatlantis3.jpg").default,
      require("../img/boats/queenatlantis4.jpg").default,
      require("../img/boats/queenatlantis5.jpg").default,
      require("../img/boats/queenatlantis6.jpg").default,
      require("../img/boats/queenatlantis7.jpg").default,
      require("../img/boats/queenatlantis8.jpg").default,
      require("../img/boats/queenatlantis9.jpg").default,
      require("../img/boats/queenatlantis10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 150,
    category: "Goulet",
    name: "Queen Lila",
    harbor: "Fethiye",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, ringo, kano, su kayağı, rüzgar sörfü",
    photo: require("../img/boats/queenlila.jpg").default,
    gallery: [
      require("../img/boats/queenlila1.jpg").default,
      require("../img/boats/queenlila2.jpg").default,
      require("../img/boats/queenlila3.jpg").default,
      require("../img/boats/queenlila4.jpg").default,
      require("../img/boats/queenlila5.jpg").default,
      require("../img/boats/queenlila6.jpg").default,
      require("../img/boats/queenlila7.jpg").default,
      require("../img/boats/queenlila8.jpg").default,
      require("../img/boats/queenlila9.jpg").default,
      require("../img/boats/queenlila10.jpg").default,
      require("../img/boats/queenlila11.jpg").default,
      require("../img/boats/queenlila12.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 151,
    category: "Goulet",
    name: "Rainbow",
    harbor: "Fethiye",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 4,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, kabin ve güvertede müzik, surf, kano, jakuzi güvertede, su kayağı",
    photo: require("../img/boats/rainbow.jpg").default,
    gallery: [
      require("../img/boats/rainbow1.jpg").default,
      require("../img/boats/rainbow2.jpg").default,
      require("../img/boats/rainbow3.jpg").default,
      require("../img/boats/rainbow4.jpg").default,
      require("../img/boats/rainbow5.jpg").default,
      require("../img/boats/rainbow6.jpg").default,
      require("../img/boats/rainbow7.jpg").default,
      require("../img/boats/rainbow8.jpg").default,
      require("../img/boats/rainbow9.jpg").default,
      require("../img/boats/rainbow10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 152,
    category: "Goulet",
    name: "Remo",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 19,
    width: 5.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "LCD TV salonda, DVD oynatıcı, Türk kara sularında internet",
    photo: require("../img/boats/remo.jpg").default,
    gallery: [
      require("../img/boats/remo1.jpg").default,
      require("../img/boats/remo2.jpg").default,
      require("../img/boats/remo3.jpg").default,
      require("../img/boats/remo4.jpg").default,
      require("../img/boats/remo5.jpg").default,
      require("../img/boats/remo6.jpg").default,
      require("../img/boats/remo7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 152,
    category: "Goulet",
    name: "Romance 1",
    harbor: "Fethiye",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 22,
    width: 5.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "LCD TV salonda, DVD oynatıcı, kahve makinası, su kayağı, ringo, wake board",
    photo: require("../img/boats/romance.jpg").default,
    gallery: [
      require("../img/boats/romance1.jpg").default,
      require("../img/boats/romance2.jpg").default,
      require("../img/boats/romance3.jpg").default,
      require("../img/boats/romance4.jpg").default,
      require("../img/boats/romance5.jpg").default,
      require("../img/boats/romance6.jpg").default,
      require("../img/boats/romance7.jpg").default,
      require("../img/boats/romance8.jpg").default,
      require("../img/boats/romance9.jpg").default,
      require("../img/boats/romance10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 153,
    category: "Goulet",
    name: "Şahinoğlu 1 ",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: null,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "LCD TV salonda ve müzik sistemi, DVD oynatıcı, kahve makinası, kano, ringo, wake board",
    photo: require("../img/boats/sahinoglu.jpg").default,
    gallery: [
      require("../img/boats/sahinoglu1.jpg").default,
      require("../img/boats/sahinoglu2.jpg").default,
      require("../img/boats/sahinoglu3.jpg").default,
      require("../img/boats/sahinoglu4.jpg").default,
      require("../img/boats/sahinoglu5.jpg").default,
      require("../img/boats/sahinoglu6.jpg").default,
      require("../img/boats/sahinoglu7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 154,
    category: "Goulet",
    name: "Salmakis",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 3,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 6.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "CD , DVD Oynatıcı, salonda tv ve müzik sistemi, rüzgar sörfü, kano",
    photo: require("../img/boats/salmakis.jpg").default,
    gallery: [
      require("../img/boats/salmakis1.jpg").default,
      require("../img/boats/salmakis2.jpg").default,
      require("../img/boats/salmakis3.jpg").default,
      require("../img/boats/salmakis4.jpg").default,
      require("../img/boats/salmakis5.jpg").default,
      require("../img/boats/salmakis6.jpg").default,
      require("../img/boats/salmakis7.jpg").default,
      require("../img/boats/salmakis8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 155,
    category: "Goulet",
    name: "Santa Maria",
    harbor: "Marmaris",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 23.9,
    width: 5.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Kano, salonda LCD tv, DVD, motorlu su sporları opsiyonel",
    photo: require("../img/boats/santamaria.jpg").default,
    gallery: [
      require("../img/boats/santamaria1.jpg").default,
      require("../img/boats/santamaria2.jpg").default,
      require("../img/boats/santamaria3.jpg").default,
      require("../img/boats/santamaria4.jpg").default,
      require("../img/boats/santamaria5.jpg").default,
      require("../img/boats/santamaria6.jpg").default,
      require("../img/boats/santamaria7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 156,
    category: "Goulet",
    name: "S Doğu",
    harbor: "Marmaris",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 8.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, salonda ve her kabinde CD - DVD oynatıcı, ringo, kano, su kayağı",
    photo: require("../img/boats/sdogu.jpg").default,
    gallery: [
      require("../img/boats/sdogu1.jpg").default,
      require("../img/boats/sdogu2.jpg").default,
      require("../img/boats/sdogu3.jpg").default,
      require("../img/boats/sdogu4.jpg").default,
      require("../img/boats/sdogu5.jpg").default,
      require("../img/boats/sdogu6.jpg").default,
      require("../img/boats/sdogu7.jpg").default,
      require("../img/boats/sdogu8.jpg").default,
      require("../img/boats/sdogu9.jpg").default,
      require("../img/boats/sdogu10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 157,
    category: "Motor Yat",
    name: "Sea Angel",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: 2,
    crew: 5,
    length: 28.7,
    width: 6.9,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "DVD, TV Uydu, Müzik sistemi TV/DVD, su kayağı, jet ski, banana",
    photo: require("../img/boats/seangel.jpg").default,
    gallery: [
      require("../img/boats/seangel1.jpg").default,
      require("../img/boats/seangel2.jpg").default,
      require("../img/boats/seangel3.jpg").default,
      require("../img/boats/seangel4.jpg").default,
      require("../img/boats/seangel5.jpg").default,
      require("../img/boats/seangel6.jpg").default,
      require("../img/boats/seangel7.jpg").default,
      require("../img/boats/seangel8.jpg").default,
      require("../img/boats/seangel9.jpg").default,
      require("../img/boats/seangel10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 158,
    category: "Goulet",
    name: "Sea Dream",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: 1,
    vipCabin: null,
    crew: 7,
    length: 39,
    width: 9.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler salon ve güvertede müzik sistemi, kabin ve salonda tv-uydu, gece Klima Kullanımı, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, saç kurutma makinesi, Salonda ve her kabinde CD - DVD oynatıcı 100 Hp. Yamaha joker bot, kano, ringo, su kayağı, wake board",
    photo: require("../img/boats/seadream.jpg").default,
    gallery: [
      require("../img/boats/seadream1.jpg").default,
      require("../img/boats/seadream2.jpg").default,
      require("../img/boats/seadream3.jpg").default,
      require("../img/boats/seadream4.jpg").default,
      require("../img/boats/seadream5.jpg").default,
      require("../img/boats/seadream6.jpg").default,
      require("../img/boats/seadream7.jpg").default,
      require("../img/boats/seadream8.jpg").default,
      require("../img/boats/seadream9.jpg").default,
      require("../img/boats/seadream10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 159,
    category: "Goulet",
    name: "Sea Life",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 19,
    width: 5.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV, kano, servis botu 60hp",
    photo: require("../img/boats/sealife.jpg").default,
    gallery: [
      require("../img/boats/sealife1.jpg").default,
      require("../img/boats/sealife2.jpg").default,
      require("../img/boats/sealife3.jpg").default,
      require("../img/boats/sealife4.jpg").default,
      require("../img/boats/sealife5.jpg").default,
      require("../img/boats/sealife6.jpg").default,
      require("../img/boats/sealife7.jpg").default,
      require("../img/boats/sealife8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 160,
    category: "Goulet",
    name: "Şeker Ayşe",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV, DVD Oynatıcı, kano",
    photo: require("../img/boats/sekerayse.jpg").default,
    gallery: [
      require("../img/boats/sekerayse1.jpg").default,
      require("../img/boats/sekerayse2.jpg").default,
      require("../img/boats/sekerayse3.jpg").default,
      require("../img/boats/sekerayse4.jpg").default,
      require("../img/boats/sekerayse5.jpg").default,
      require("../img/boats/sekerayse6.jpg").default,
      require("../img/boats/sekerayse7.jpg").default,
      require("../img/boats/sekerayse8.jpg").default,
      require("../img/boats/sekerayse9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 161,
    category: "Goulet",
    name: "Sema Tuana",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kablosoz internet, her kabinde LCD TV ve CD DIVX oynatıcı, CD ve DVD koleksiyonu, tiyatro müzik sistemi, 2 kano 100 hp motor bot, su kayağı, jet ski opsiyonel, bulaşık ve çamaşır makinası ve kurutma, 2 kano, Paddleboard Inflatable Power Boat with 100 HP motor bot (optional), yetişkinler için su kayağı çocuklar için opsiyonel, Jet-Ski (optional)",
    photo: require("../img/boats/sematuana.jpg").default,
    gallery: [
      require("../img/boats/sematuana1.jpg").default,
      require("../img/boats/sematuana2.jpg").default,
      require("../img/boats/sematuana3.jpg").default,
      require("../img/boats/sematuana4.jpg").default,
      require("../img/boats/sematuana5.jpg").default,
      require("../img/boats/sematuana6.jpg").default,
      require("../img/boats/sematuana7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 162,
    category: "Goulet",
    name: "Semercioğlu IV",
    harbor: "Fethiye",
    capacity: 20,
    cabin: 9,
    masterCabin: null,
    doubleCabin: 9,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 40,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & müzik sistemi, buz makinası, şaraplık, çamaşır makinası, kano 2 adet",
    photo: require("../img/boats/semercioglu.jpg").default,
    gallery: [
      require("../img/boats/semercioglu1.jpg").default,
      require("../img/boats/semercioglu2.jpg").default,
      require("../img/boats/semercioglu3.jpg").default,
      require("../img/boats/semercioglu4.jpg").default,
      require("../img/boats/semercioglu5.jpg").default,
      require("../img/boats/semercioglu6.jpg").default,
      require("../img/boats/semercioglu7.jpg").default,
      require("../img/boats/semercioglu8.jpg").default,
      require("../img/boats/semercioglu9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 163,
    category: "Goulet",
    name: "Serenad",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 29,
    width: 7.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinlerde duşakabin, buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kano, Rüzgar sörfü",
    photo: require("../img/boats/serenad.png").default,
    gallery: [
      require("../img/boats/serenad1.png").default,
      require("../img/boats/serenad2.png").default,
      require("../img/boats/serenad3.png").default,
      require("../img/boats/serenad4.png").default,
      require("../img/boats/serenad5.png").default,
      require("../img/boats/serenad6.png").default,
      require("../img/boats/serenad7.png").default,
      require("../img/boats/serenad8.png").default,
      require("../img/boats/serenad9.png").default,
      require("../img/boats/serenad10.png").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 164,
    category: "Goulet",
    name: "Serenity 70",
    harbor: "Göcek",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 21.3,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, İnternet bağlantısı, 100 adet DVD arşivi, 100 adet albüm arşivi, Zodiac 60 Hp motor bot, 2 adet kano, su kayağı, mono kayak, kneeboard, wakeboard, 360 degree extreme, salonda tv, güvertede müzik sistemi",
    photo: require("../img/boats/serenityyetmis.jpg").default,
    gallery: [
      require("../img/boats/serenityyetmis1.jpg").default,
      require("../img/boats/serenityyetmis2.jpg").default,
      require("../img/boats/serenityyetmis3.jpg").default,
      require("../img/boats/serenityyetmis4.jpg").default,
      require("../img/boats/serenityyetmis5.jpg").default,
      require("../img/boats/serenityyetmis6.jpg").default,
      require("../img/boats/serenityyetmis7.jpg").default,
      require("../img/boats/serenityyetmis8.jpg").default,
      require("../img/boats/serenityyetmis9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 165,
    category: "Goulet",
    name: "Serenity 86",
    harbor: "Göcek",
    capacity: 8,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: 1,
    crew: 4,
    length: 26,
    width: 7.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, İnternet bağlantısı, 100 adet DVD arşivi, 100 adet albüm arşivi, Zodiac 60 Hp motor bot, 2 adet kano, su kayağı, mono kayak, kneeboard, wakeboard, 360 degree extreme, salonda tv, güvertede müzik sistemi",
    photo: require("../img/boats/serenityseksenalti.jpg").default,
    gallery: [
      require("../img/boats/serenityseksenalti1.jpg").default,
      require("../img/boats/serenityseksenalti2.jpg").default,
      require("../img/boats/serenityseksenalti3.jpg").default,
      require("../img/boats/serenityseksenalti4.jpg").default,
      require("../img/boats/serenityseksenalti5.jpg").default,
      require("../img/boats/serenityseksenalti6.jpg").default,
      require("../img/boats/serenityseksenalti7.jpg").default,
      require("../img/boats/serenityseksenalti8.jpg").default,
      require("../img/boats/serenityseksenalti9.jpg").default,
      require("../img/boats/serenityseksenalti10.jpg").default,
      require("../img/boats/serenityseksenalti11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 166,
    category: "Goulet",
    name: "Sezgin",
    harbor: "Fethiye",
    capacity: 6,
    cabin: 3,
    masterCabin: null,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 14.3,
    width: 4.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "CD çalar, snorkel, olta takımı",
    photo: require("../img/boats/sezgin.jpg").default,
    gallery: [
      require("../img/boats/sezgin1.jpg").default,
      require("../img/boats/sezgin2.jpg").default,
      require("../img/boats/sezgin3.jpg").default,
      require("../img/boats/sezgin4.jpg").default,
      require("../img/boats/sezgin5.jpg").default,
      require("../img/boats/sezgin6.jpg").default,
      require("../img/boats/sezgin7.jpg").default,
      require("../img/boats/sezgin8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 167,
    category: "Goulet",
    name: "Shatz",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 30,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, kano, ringo, su kayağı, mono ski, Idock, joker 115 hp",
    photo: require("../img/boats/shatz.jpg").default,
    gallery: [
      require("../img/boats/shatz1.jpg").default,
      require("../img/boats/shatz2.jpg").default,
      require("../img/boats/shatz3.jpg").default,
      require("../img/boats/shatz4.jpg").default,
      require("../img/boats/shatz5.jpg").default,
      require("../img/boats/shatz6.jpg").default,
      require("../img/boats/shatz7.jpg").default,
      require("../img/boats/shatz8.jpg").default,
      require("../img/boats/shatz9.jpg").default,
      require("../img/boats/shatz10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 168,
    category: "Goulet",
    name: "Silver Moon",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: 2,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 36,
    width: 8.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, her kabinbe saç kurutma makinesi ve güvenlik kasası, CD - DVD Oynatıcı, su kayağı, 2 paddle board, wakeboard, banana, ringo, 140 hp joker bot",
    photo: require("../img/boats/silvermoon.jpg").default,
    gallery: [
      require("../img/boats/silvermoon1.jpg").default,
      require("../img/boats/silvermoon2.jpg").default,
      require("../img/boats/silvermoon3.jpg").default,
      require("../img/boats/silvermoon4.jpg").default,
      require("../img/boats/silvermoon5.jpg").default,
      require("../img/boats/silvermoon6.jpg").default,
      require("../img/boats/silvermoon7.jpg").default,
      require("../img/boats/silvermoon8.jpg").default,
      require("../img/boats/silvermoon9.jpg").default,
      require("../img/boats/silvermoon10.jpg").default,
      require("../img/boats/silvermoon12.jpg").default,
      require("../img/boats/silvermoon13.jpg").default,
      require("../img/boats/silvermoon14.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 169,
    category: "Goulet",
    name: "Simge Can",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 8,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 27,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, her kabinbe saç kurutma makinesi",
    photo: require("../img/boats/simgecan.jpg").default,
    gallery: [
      require("../img/boats/simgecan1.jpg").default,
      require("../img/boats/simgecan2.jpg").default,
      require("../img/boats/simgecan3.jpg").default,
      require("../img/boats/simgecan4.jpg").default,
      require("../img/boats/simgecan5.jpg").default,
      require("../img/boats/simgecan6.jpg").default,
      require("../img/boats/simgecan7.jpg").default,
      require("../img/boats/simgecan8.jpg").default,
      require("../img/boats/simgecan9.jpg").default,
      require("../img/boats/simgecan10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 170,
    category: "Goulet",
    name: "Smyrna",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, kahve makinesi, salonda TV & DVD oynatıcı,  salonda müzik sistemi, kano, ringo, wakeboard",
    photo: require("../img/boats/smyrna.jpg").default,
    gallery: [
      require("../img/boats/smyrna1.jpg").default,
      require("../img/boats/smyrna2.jpg").default,
      require("../img/boats/smyrna3.jpg").default,
      require("../img/boats/smyrna4.jpg").default,
      require("../img/boats/smyrna5.jpg").default,
      require("../img/boats/smyrna6.jpg").default,
      require("../img/boats/smyrna7.jpg").default,
      require("../img/boats/smyrna8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 171,
    category: "Goulet",
    name: "Sofia",
    harbor: "Marmaris",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 2,
    length: 17.5,
    width: 5.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Tv- DVD müzik sistemi, kano",
    photo: require("../img/boats/sofia.jpg").default,
    gallery: [
      require("../img/boats/sofia1.jpg").default,
      require("../img/boats/sofia2.jpg").default,
      require("../img/boats/sofia3.jpg").default,
      require("../img/boats/sofia4.jpg").default,
      require("../img/boats/sofia5.jpg").default,
      require("../img/boats/sofia6.jpg").default,
      require("../img/boats/sofia7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 172,
    category: "Sailing Boat",
    name: "Su sesi",
    harbor: "Fethiye",
    capacity: 10,
    cabin: 5,
    masterCabin: 2,
    doubleCabin: 3,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 25,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda Tv- DVD müzik sistemi, kano, buz makinası",
    photo: require("../img/boats/susesi.jpg").default,
    gallery: [
      require("../img/boats/susesi1.jpg").default,
      require("../img/boats/susesi2.jpg").default,
      require("../img/boats/susesi3.jpg").default,
      require("../img/boats/susesi4.jpg").default,
      require("../img/boats/susesi5.jpg").default,
      require("../img/boats/susesi6.jpg").default,
      require("../img/boats/susesi7.jpg").default,
      require("../img/boats/susesi8.jpg").default,
      require("../img/boats/susesi9.jpg").default,
      require("../img/boats/susesi10.jpg").default,
      require("../img/boats/susesi11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 173,
    category: "Goulet",
    name: "Sultan A",
    harbor: "Bodrum",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 28,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda Tv- DVD müzik sistemi, kano, buz makinası",
    photo: require("../img/boats/sultan.jpg").default,
    gallery: [
      require("../img/boats/sultan1.jpg").default,
      require("../img/boats/sultan2.jpg").default,
      require("../img/boats/sultan3.jpg").default,
      require("../img/boats/sultan4.jpg").default,
      require("../img/boats/sultan5.jpg").default,
      require("../img/boats/sultan6.jpg").default,
      require("../img/boats/sultan7.jpg").default,
      require("../img/boats/sultan8.jpg").default,
      require("../img/boats/sultan9.jpg").default,
      require("../img/boats/sultan10.jpg").default,
      require("../img/boats/sultan12.jpg").default,
      require("../img/boats/sultan13.jpg").default,
      require("../img/boats/sultan14.jpg").default,
      require("../img/boats/sultan15.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 174,
    category: "Goulet",
    name: "Sun World IX",
    harbor: "Bodrum",
    capacity: 18,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: 4,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 7.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD & müzik, güvertede Mini Bar , uydu Anten , Ipad bağlantısı, mikrodalga fırın , tost Makinesi, bulaşık makinesi, kahve makinesi , Salonda TV , DVD / CD oynatıcı, tüm kabinlerde duşakabin , Windsurf",
    photo: require("../img/boats/sunwdokuz.jpg").default,
    gallery: [
      require("../img/boats/sunwdokuz1.jpg").default,
      require("../img/boats/sunwdokuz2.jpg").default,
      require("../img/boats/sunwdokuz3.jpg").default,
      require("../img/boats/sunwdokuz4.jpg").default,
      require("../img/boats/sunwdokuz5.jpg").default,
      require("../img/boats/sunwdokuz6.jpg").default,
      require("../img/boats/sunwdokuz7.jpg").default,
      require("../img/boats/sunwdokuz8.jpg").default,
      require("../img/boats/sunwdokuz9.jpg").default,
      require("../img/boats/sunwdokuz10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 175,
    category: "Goulet",
    name: "Sun World VIII",
    harbor: "Bodrum",
    capacity: 17,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: 2,
    tripleCabin: 1,
    vipCabin: null,
    crew: 4,
    length: 30,
    width: 6.3,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Salonda TV & DVD & müzik, internet bağlantısı, kano",
    photo: require("../img/boats/sunwsekiz.jpg").default,
    gallery: [
      require("../img/boats/sunwsekiz1.jpg").default,
      require("../img/boats/sunwsekiz2.jpg").default,
      require("../img/boats/sunwsekiz3.jpg").default,
      require("../img/boats/sunwsekiz4.jpg").default,
      require("../img/boats/sunwsekiz5.jpg").default,
      require("../img/boats/sunwsekiz6.jpg").default,
      require("../img/boats/sunwsekiz7.jpg").default,
      require("../img/boats/sunwsekiz8.jpg").default,
      require("../img/boats/sunwsekiz9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 176,
    category: "Goulet",
    name: "Tarkan V",
    harbor: "Fethiye",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: 2,
    vipCabin: null,
    crew: 5,
    length: 36,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD & müzik, CD Oynatıcı, Kahve makinesi, Şarap soğutucu, her kabinde saç kurutma makinası, 60 Hp motorbot, Su kayağı, ringo, kano, sörf",
    photo: require("../img/boats/tarkan.jpg").default,
    gallery: [
      require("../img/boats/tarkan1.jpg").default,
      require("../img/boats/tarkan2.jpg").default,
      require("../img/boats/tarkan3.jpg").default,
      require("../img/boats/tarkan4.jpg").default,
      require("../img/boats/tarkan5.jpg").default,
      require("../img/boats/tarkan6.jpg").default,
      require("../img/boats/tarkan7.jpg").default,
      require("../img/boats/tarkan8.jpg").default,
      require("../img/boats/tarkan9.jpg").default,
      require("../img/boats/tarkan10.jpg").default,
      require("../img/boats/tarkan11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 177,
    category: "Goulet",
    name: "Tersane VIII",
    harbor: "Fethiye",
    capacity: 28,
    cabin: 14,
    masterCabin: null,
    doubleCabin: 10,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 42,
    width: 9.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, salonda TV CD-DVD Oynatıcı, kahve makinesi, şarap soğutucu",
    photo: require("../img/boats/tersane.jpg").default,
    gallery: [
      require("../img/boats/tersane1.jpg").default,
      require("../img/boats/tersane2.jpg").default,
      require("../img/boats/tersane3.jpg").default,
      require("../img/boats/tersane4.jpg").default,
      require("../img/boats/tersane5.jpg").default,
      require("../img/boats/tersane6.jpg").default,
      require("../img/boats/tersane7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 178,
    category: "Goulet",
    name: "Trippin",
    harbor: "Bodrum",
    capacity: 8,
    cabin: 4,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 6.5,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Buz makinesi, su kayağı, kano, olta takımları",
    photo: require("../img/boats/trippin.jpg").default,
    gallery: [
      require("../img/boats/trippin1.jpg").default,
      require("../img/boats/trippin2.jpg").default,
      require("../img/boats/trippin3.jpg").default,
      require("../img/boats/trippin4.jpg").default,
      require("../img/boats/trippin5.jpg").default,
      require("../img/boats/trippin6.jpg").default,
      require("../img/boats/trippin7.jpg").default,
      require("../img/boats/trippin8.jpg").default,
      require("../img/boats/trippin9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 179,
    category: "Goulet",
    name: "Tufan 5",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 4,
    masterCabin: 1,
    doubleCabin: 4,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 23,
    width: 6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda DVD, TV, müzik seti, 40hp motor bot, su kayağı, ringo, olta takımları",
    photo: require("../img/boats/tufan.jpg").default,
    gallery: [
      require("../img/boats/tufan1.jpg").default,
      require("../img/boats/tufan2.jpg").default,
      require("../img/boats/tufan3.jpg").default,
      require("../img/boats/tufan4.jpg").default,
      require("../img/boats/tufan5.jpg").default,
      require("../img/boats/tufan6.jpg").default,
      require("../img/boats/tufan7.jpg").default,
      require("../img/boats/tufan8.jpg").default,
      require("../img/boats/tufan9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 180,
    category: "Goulet",
    name: "Uğur",
    harbor: "Marmaris",
    capacity: 14,
    cabin: 7,
    masterCabin: 1,
    doubleCabin: 6,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi, CD DVD oynatıcı, kahve makinesi, şarap soğutucu, Türk karasularında internet bağlantısı, Saç kurutma makinesi, ringo, su kayağı",
    photo: require("../img/boats/ugur.jpg").default,
    gallery: [
      require("../img/boats/ugur1.jpg").default,
      require("../img/boats/ugur2.jpg").default,
      require("../img/boats/ugur3.jpg").default,
      require("../img/boats/ugur4.jpg").default,
      require("../img/boats/ugur5.jpg").default,
      require("../img/boats/ugur6.jpg").default,
      require("../img/boats/ugur7.jpg").default,
      require("../img/boats/ugur8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 181,
    category: "Goulet",
    name: "Uğur Kaan",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 6,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 27,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Servis botu 8.8 hp",
    photo: require("../img/boats/ugurkaan.jpg").default,
    gallery: [
      require("../img/boats/ugurkaan1.jpg").default,
      require("../img/boats/ugurkaan2.jpg").default,
      require("../img/boats/ugurkaan3.jpg").default,
      require("../img/boats/ugurkaan4.jpg").default,
      require("../img/boats/ugurkaan5.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 182,
    category: "Goulet",
    name: "Ulu Çınar",
    harbor: "Bodrum",
    capacity: 14,
    cabin: 7,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25,
    width: 6.4,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Servis botu 8.8 hp, salonda TV&DVD müzik sistemi, kano",
    photo: require("../img/boats/ulucinar.jpg").default,
    gallery: [
      require("../img/boats/ulucinar1.jpg").default,
      require("../img/boats/ulucinar2.jpg").default,
      require("../img/boats/ulucinar3.jpg").default,
      require("../img/boats/ulucinar4.jpg").default,
      require("../img/boats/ulucinar5.jpg").default,
      require("../img/boats/ulucinar6.jpg").default,
      require("../img/boats/ulucinar7.jpg").default,
      require("../img/boats/ulucinar8.jpg").default,
      require("../img/boats/ulucinar9.jpg").default,
      require("../img/boats/ulucinar10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 183,
    category: "Goulet",
    name: "Umut",
    harbor: "Marmaris",
    capacity: 14,
    cabin: 7,
    masterCabin: null,
    doubleCabin: 5,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 26,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other: "Servis botu 8.8 hp, kano, kahve ve buz makinası",
    photo: require("../img/boats/umut.jpg").default,
    gallery: [
      require("../img/boats/umut1.jpg").default,
      require("../img/boats/umut2.jpg").default,
      require("../img/boats/umut3.jpg").default,
      require("../img/boats/umut4.jpg").default,
      require("../img/boats/umut5.jpg").default,
      require("../img/boats/umut6.jpg").default,
      require("../img/boats/umut7.jpg").default,
      require("../img/boats/umut8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 184,
    category: "Goulet",
    name: "Vesta I Sevil",
    harbor: "Marmaris",
    capacity: 16,
    cabin: 8,
    masterCabin: null,
    doubleCabin: 4,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 32,
    width: 7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda DVD & TV, müzik sistemi, Flybridge ( üst güverte ) de jakuzi, Dalış malzemeleri, 40 HP motorbot, kano, kahve ve buz makinası, Espresso makinesi, Filtre Kahve Makinesi, Şarap soğutucu, Türk karasularında internet bağlantısı, saç kurutma makinesi",
    photo: require("../img/boats/vesta.jpg").default,
    gallery: [
      require("../img/boats/vesta1.jpg").default,
      require("../img/boats/vesta2.jpg").default,
      require("../img/boats/vesta3.jpg").default,
      require("../img/boats/vesta4.jpg").default,
      require("../img/boats/vesta5.jpg").default,
      require("../img/boats/vesta6.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 185,
    category: "Goulet",
    name: "Vongole",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 5.7,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda CD - DVD Oynatıcı, buz ve Kahve makinesi, Türk karasularında internet bağlantısı, kano",
    photo: require("../img/boats/vongole.jpg").default,
    gallery: [
      require("../img/boats/vongole1.jpg").default,
      require("../img/boats/vongole2.jpg").default,
      require("../img/boats/vongole3.jpg").default,
      require("../img/boats/vongole4.jpg").default,
      require("../img/boats/vongole5.jpg").default,
      require("../img/boats/vongole6.jpg").default,
      require("../img/boats/vongole7.jpg").default,
      require("../img/boats/vongole8.jpg").default,
      require("../img/boats/vongole9.jpg").default,
      require("../img/boats/vongole10.jpg").default,
      require("../img/boats/vongole11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 186,
    category: "Goulet",
    name: "White Goose",
    harbor: "Bodrum",
    capacity: 6,
    cabin: 3,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: 1,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 24,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV, salon ve güvertede müzik sistemi, kahve ve buz makinası, 50 hp joker bot, su kayağıçocuklar için, ringo, banana, kano, 2 paddle board",
    photo: require("../img/boats/whitegoose.jpg").default,
    gallery: [
      require("../img/boats/whitegoose1.jpg").default,
      require("../img/boats/whitegoose2.jpg").default,
      require("../img/boats/whitegoose3.jpg").default,
      require("../img/boats/whitegoose4.jpg").default,
      require("../img/boats/whitegoose5.jpg").default,
      require("../img/boats/whitegoose6.jpg").default,
      require("../img/boats/whitegoose7.jpg").default,
      require("../img/boats/whitegoose8.jpg").default,
      require("../img/boats/whitegoose9.jpg").default,
      require("../img/boats/whitegoose10.jpg").default,
      require("../img/boats/whitegoose11.jpg").default,
      require("../img/boats/whitegoose12.jpg").default,
      require("../img/boats/whitegoose13.jpg").default,
      require("../img/boats/whitegoose14.jpg").default,
      require("../img/boats/whitegoose15.jpg").default,
      require("../img/boats/whitegoose16.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 187,
    category: "Goulet",
    name: "White Soul",
    harbor: "Bodrum",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 38,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda ve kabinlerde  TV & DVD oynatıcı ve müzik sistemi, Buz makinesi, Kahve makinesi, Şarap soğutucu, Saç kurutma makinesi, Türk karasularında internet bağlantısı, kano, su kayağı, rüzgar sörfü, 80 hp motor bot",
    photo: require("../img/boats/whitesoul.jpg").default,
    gallery: [
      require("../img/boats/whitesoul1.jpg").default,
      require("../img/boats/whitesoul2.jpg").default,
      require("../img/boats/whitesoul3.jpg").default,
      require("../img/boats/whitesoul4.jpg").default,
      require("../img/boats/whitesoul5.jpg").default,
      require("../img/boats/whitesoul6.jpg").default,
      require("../img/boats/whitesoul7.jpg").default,
      require("../img/boats/whitesoul8.jpg").default,
      require("../img/boats/whitesoul9.jpg").default,
      require("../img/boats/whitesoul10.jpg").default,
      require("../img/boats/whitesoul11.jpg").default,
      require("../img/boats/whitesoul12.jpg").default,
      require("../img/boats/whitesoul13.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 188,
    category: "Goulet",
    name: "Ya Selam",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: null,
    doubleCabin: 2,
    twinCabin: 4,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 25.5,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Servis botu 60 HP, kano, su kayağı, ringo, balık tutma ekipmanları, maske, palet, şnorkel",
    photo: require("../img/boats/yaselam.jpg").default,
    gallery: [
      require("../img/boats/yaselam1.jpg").default,
      require("../img/boats/yaselam2.jpg").default,
      require("../img/boats/yaselam3.jpg").default,
      require("../img/boats/yaselam4.jpg").default,
      require("../img/boats/yaselam5.jpg").default,
      require("../img/boats/yaselam6.jpg").default,
      require("../img/boats/yaselam7.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 189,
    category: "Goulet",
    name: "Yörükoğlu 2",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 29,
    width: 7.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Salonda TV & DVD oynatıcı ve müzik sistemi, kano, servis botu, Türk karasularında internet",
    photo: require("../img/boats/yorukoglu.jpg").default,
    gallery: [
      require("../img/boats/yorukoglu1.jpg").default,
      require("../img/boats/yorukoglu2.jpg").default,
      require("../img/boats/yorukoglu3.jpg").default,
      require("../img/boats/yorukoglu4.jpg").default,
      require("../img/boats/yorukoglu5.jpg").default,
      require("../img/boats/yorukoglu6.jpg").default,
      require("../img/boats/yorukoglu7.jpg").default,
      require("../img/boats/yorukoglu8.jpg").default,
      require("../img/boats/yorukoglu9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 190,
    category: "Goulet",
    name: "Yücebey",
    harbor: "Marmaris",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, kano, sörf, ringo, su kayağı",
    photo: require("../img/boats/yucebey.jpg").default,
    gallery: [
      require("../img/boats/yucebey1.jpg").default,
      require("../img/boats/yucebey2.jpg").default,
      require("../img/boats/yucebey3.jpg").default,
      require("../img/boats/yucebey4.jpg").default,
      require("../img/boats/yucebey5.jpg").default,
      require("../img/boats/yucebey6.jpg").default,
      require("../img/boats/yucebey7.jpg").default,
      require("../img/boats/yucebey8.jpg").default,
      require("../img/boats/yucebey9.jpg").default,
      require("../img/boats/yucebey10.jpg").default,
      require("../img/boats/yucebey11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 191,
    category: "Goulet",
    name: "Yücebey I",
    harbor: "Marmaris",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 24,
    width: 6.2,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD Oynatıcı, DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, kano, sörf, ringo, su kayağı",
    photo: require("../img/boats/yucebeybir.jpg").default,
    gallery: [
      require("../img/boats/yucebeybir1.jpg").default,
      require("../img/boats/yucebeybir2.jpg").default,
      require("../img/boats/yucebeybir3.jpg").default,
      require("../img/boats/yucebeybir4.jpg").default,
      require("../img/boats/yucebeybir5.jpg").default,
      require("../img/boats/yucebeybir6.jpg").default,
      require("../img/boats/yucebeybir7.jpg").default,
      require("../img/boats/yucebeybir8.jpg").default,
      require("../img/boats/yucebeybir9.jpg").default,
      require("../img/boats/yucebeybir10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 192,
    category: "Goulet",
    name: "Zekioğlu",
    harbor: "Marmaris",
    capacity: 12,
    cabin: 6,
    masterCabin: 1,
    doubleCabin: 5,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 4,
    length: 26,
    width: 6.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "CD -DVD oynatıcı, kano, servis botu, balık tuma takımları, kahve-buz makinası",
    photo: require("../img/boats/zekioglu.jpg").default,
    gallery: [
      require("../img/boats/zekioglu1.jpg").default,
      require("../img/boats/zekioglu2.jpg").default,
      require("../img/boats/zekioglu3.jpg").default,
      require("../img/boats/zekioglu4.jpg").default,
      require("../img/boats/zekioglu5.jpg").default,
      require("../img/boats/zekioglu6.jpg").default,
      require("../img/boats/zekioglu7.jpg").default,
      require("../img/boats/zekioglu8.jpg").default,
      require("../img/boats/zekioglu9.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 193,
    category: "Goulet",
    name: "Zelda",
    harbor: "Göcek",
    capacity: 10,
    cabin: 5,
    masterCabin: 1,
    doubleCabin: null,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: 2,
    crew: 6,
    length: 40,
    width: 8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Kabinler,Salon ve Güvertede müzik sistemi, Gece Klima Kullanımı, CD DVD Oynatıcı, Kahve makinesi, Şarap soğutucu, İnternet bağlantısı, Saç kurutma makinesi, Double kabinde CD - DVD oynatıcı, 6 m. 130 Hp motor bot, ringo, su kayağı, wakeboard",
    photo: require("../img/boats/zelda.jpg").default,
    gallery: [
      require("../img/boats/zelda1.jpg").default,
      require("../img/boats/zelda2.jpg").default,
      require("../img/boats/zelda3.jpg").default,
      require("../img/boats/zelda4.jpg").default,
      require("../img/boats/zelda5.jpg").default,
      require("../img/boats/zelda6.jpg").default,
      require("../img/boats/zelda7.jpg").default,
      require("../img/boats/zelda8.jpg").default,
      require("../img/boats/zelda9.jpg").default,
      require("../img/boats/zelda10.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 194,
    category: "Goulet",
    name: "Zephyra II",
    harbor: "Bodrum",
    capacity: 12,
    cabin: 6,
    masterCabin: 2,
    doubleCabin: 2,
    twinCabin: 2,
    tripleCabin: null,
    vipCabin: null,
    crew: 5,
    length: 32,
    width: 7.8,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Servis botu (60 HP), kano, wakeboard, banana, su kayağı, ringo, paddle board, balık tutma ekipmanları, maske, palet, şnorkel.",
    photo: require("../img/boats/zephyra.jpg").default,
    gallery: [
      require("../img/boats/zephyra1.jpg").default,
      require("../img/boats/zephyra2.jpg").default,
      require("../img/boats/zephyra3.jpg").default,
      require("../img/boats/zephyra4.jpg").default,
      require("../img/boats/zephyra5.jpg").default,
      require("../img/boats/zephyra6.jpg").default,
      require("../img/boats/zephyra7.jpg").default,
      require("../img/boats/zephyra8.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
  {
    id: 195,
    category: "Goulet",
    name: "Zorba",
    harbor: "Bodrum",
    capacity: 5,
    cabin: 2,
    masterCabin: 1,
    doubleCabin: 1,
    twinCabin: null,
    tripleCabin: null,
    vipCabin: null,
    crew: 3,
    length: 20,
    width: 5.6,
    equipments:
      "Tam güvenlik ekipmanları, Can yelekleri, Salonda müzik sistemi, Navigasyon sistemi, Yangın söndürücüler, Personel kabini, Salonda yemek alanı ve oturma grubu, VHF radyo, Tüm kabinlerde WC, Kabinlerde nevresim, çarşaf, banyo ve el havluları, Sıcak su sistemi, Donanımlı mutfak, Buzdolabı, Fırın ve Ocak, Buz makinası, Derin dondurucu, Güvertede oturma grubu ve yemek alanı, Güneşlenme minderleri, Güvertede duş, Deniz Merdiveni, Olta takımı, Şnorkel-maske-palet, Tavla-oyun kağıdı, Standart yelken donanımı",
    other:
      "Buz makinesi,master kabinde tv, müzik sistemi, wifi bağlantısı, filtre kahve makinası, tam yelken donanımı, paddle board",
    photo: require("../img/boats/zorba.jpg").default,
    gallery: [
      require("../img/boats/zorba1.jpg").default,
      require("../img/boats/zorba2.jpg").default,
      require("../img/boats/zorba3.jpg").default,
      require("../img/boats/zorba4.jpg").default,
      require("../img/boats/zorba5.jpg").default,
      require("../img/boats/zorba6.jpg").default,
      require("../img/boats/zorba7.jpg").default,
      require("../img/boats/zorba8.jpg").default,
      require("../img/boats/zorba9.jpg").default,
      require("../img/boats/zorba10.jpg").default,
      require("../img/boats/zorba11.jpg").default,
    ],
    aprilPrice: "1.000",
    mayPrice: "1.000",
    junePrice: "1.000",
    julyPrice: "1.000",
    augustPrice: "1.000",
    septemberPrice: "1.000",
    octoberPrice: "1.000",
  },
];
